(function(){
'use strict';
var __m=Object.create(null);
__m["text"] = (function () {
function own(obj,key){
if(!obj||typeof obj!=='object'||typeof key!=='string')return undefined;
return Object.prototype.hasOwnProperty.call(obj,key)?obj[key]:undefined;
}
function str(v){
if(typeof v!=='string')return null;
const t=v.trim();
return t===''?null:t;
}
const PLACEHOLDER= /\{([A-Za-z0-9_]+)\}/g;
function fill(template,vars){
if(typeof template!=='string')return null;
let complete=true;
const out=template.replace(PLACEHOLDER,(match,key)=>{
const v=own(vars,key);
if(v===undefined||v===null||v===''){complete=false;return match;}
return String(v);
});
if(!complete)return null;
return str(out);
}
function hasPlaceholder(s){
return typeof s==='string'&& /\{[A-Za-z0-9_]+\}/.test(s);
}
function displayNameOf(deck){
if(!deck)return null;
return str(deck.display_name)||str(deck.name);
}
function deckName(data,deckId){
const decks=data&&Array.isArray(data.decks)?data.decks:[];
for(const d of decks){
if(d&&d.deck_id===deckId)return displayNameOf(d)||deckId;
}
return deckId;
}
function stripLeadingLabel(text,label){
if(typeof text!=='string'||typeof label!=='string'||label==='')return text;
const esc=label.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
const re=new RegExp('^\\s*'+esc+'(?!\\p{L})[,.:;!?]*\\s*[-–—]?\\s*','iu');
const out=text.replace(re,'').trim();
if(out==='')return text;
return out.charAt(0).toUpperCase()+out.slice(1);
}
const ZERO_WIDTH= /[\u00AD\u034F\u061C\u180E\u200B\u200C\u200D\u200E\u200F\u202A-\u202E\u2060\u2062\u2064\u2066\uFE0F\uFEFF]/g;
const SINGLE_QUOTES= /['\u2018\u2019\u201B\u02BC\u2032`\u00B4]/g;
const DOUBLE_QUOTES= /["\u201C\u201D\u201E\u2033]/g;
const DASHES= /[\u2013\u2014\u2011]/g;
const WHITESPACE_RUN= /\s+/g;
function normalizeSafetyText(s){
if(typeof s!=='string')return'';
return s
.normalize('NFKC')
.toLowerCase()
.replace(SINGLE_QUOTES,'\'')
.replace(DOUBLE_QUOTES,'"')
.replace(DASHES,'-')
.replace(ZERO_WIDTH,'')
.replace(WHITESPACE_RUN,' ')
.trim();
}
const EDGE_PUNCT= /^[.,!?;:()[\]{}"„“”«»…]+|[.,!?;:()[\]{}"„“”«»…]+$/g;
const cleanToken=(w)=>w.replace(EDGE_PUNCT,'');
function windowMatch(text,term){
const termWords=term.split(' ').filter(Boolean);
if(termWords.length<2)return false;
const qWords=text.split(' ').map(cleanToken).filter(Boolean);
const window=Math.max(5,termWords.length);
const need=new Set(termWords);
const n=qWords.length;
for(let start=0;start<n;start++){
const end=Math.min(n,start+window);
const seen=new Set();
for(let i=start;i<end;i++)seen.add(qWords[i]);
let all=true;
for(const w of need){if(!seen.has(w)){all=false;break;}}
if(all)return true;
}
return false;
}
function wordOverlap(a,b){
const words=(s)=>new Set(String(s||'').toLowerCase().match(/[a-z']+/g)||[]);
const wa=words(a);
const wb=words(b);
if(!wa.size||!wb.size)return 0;
let shared=0;
for(const w of wa)if(wb.has(w))shared++;
return shared / new Set([...wa,...wb]).size;
}

return { "own": own, "str": str, "fill": fill, "hasPlaceholder": hasPlaceholder, "displayNameOf": displayNameOf, "deckName": deckName, "stripLeadingLabel": stripLeadingLabel, "normalizeSafetyText": normalizeSafetyText, "windowMatch": windowMatch, "wordOverlap": wordOverlap };
})();

__m["dates"] = (function () {
const DAYS=[31,28,31,30,31,30,31,31,30,31,30,31];
function isLeap(y){
return(y%4===0&&y%100!==0)||y%400===0;
}
function daysInMonth(year,month){
return month===2&&isLeap(year)?29:DAYS[month-1];
}
function checkDate(year,month,day,who){
for(const v of[year,month,day]){
if(typeof v!=='number'||!Number.isInteger(v))throw new TypeError('df-rr: '+who+' needs three integers');
}
if(year<1||year>9999)throw new RangeError('df-rr: year out of range');
if(month<1||month>12)throw new RangeError('df-rr: month out of range');
if(day<1||day>daysInMonth(year,month))throw new RangeError('df-rr: day out of range for that month');
}

return { "isLeap": isLeap, "daysInMonth": daysInMonth, "checkDate": checkDate };
})();

__m["cards"] = (function () {
const SUITS=['wands','cups','swords','pentacles'];
function build(){
const ids=[];
for(let n=0;n<=21;n++)ids.push('major-'+String(n).padStart(2,'0'));
for(const suit of SUITS){
for(let n=1;n<=14;n++)ids.push(suit+'-'+String(n).padStart(2,'0'));
}
return ids;
}
const CARD_IDS=Object.freeze(build());
const INDEX=(()=>{
const m=Object.create(null);
CARD_IDS.forEach((id,i)=>{m[id]=i;});
return m;
})();
function cardIndex(id){
if(typeof id!=='string')return-1;
const i=INDEX[id];
return typeof i==='number'?i:-1;
}
function isCardId(id){
return cardIndex(id)!==-1;
}
function cardName(data,id){
if(!isCardId(id))return null;
const cards=data&&data.cards;
if(!cards||typeof cards!=='object')return null;
if(!Object.prototype.hasOwnProperty.call(cards,id))return null;
const card=cards[id];
if(!card||typeof card!=='object')return null;
if(typeof card.name!=='string')return null;
const t=card.name.trim();
return t===''?null:t;
}
function arcanaOf(id){
if(!isCardId(id))return null;
return id.charCodeAt(0)===109?'major':'minor';
}
function suitOf(id){
if(!isCardId(id))return null;
const dash=id.lastIndexOf('-');
const s=id.slice(0,dash);
return s==='major'?null:s;
}
function numberOf(id){
if(!isCardId(id))return-1;
return Number(id.slice(id.lastIndexOf('-')+1));
}
function isCourt(id){
const n=numberOf(id);
return suitOf(id)!==null&&n>=11&&n<=14;
}
function isAce(id){
return suitOf(id)!==null&&numberOf(id)===1;
}

return { "SUITS": SUITS, "CARD_IDS": CARD_IDS, "cardIndex": cardIndex, "isCardId": isCardId, "cardName": cardName, "arcanaOf": arcanaOf, "suitOf": suitOf, "numberOf": numberOf, "isCourt": isCourt, "isAce": isAce };
})();

__m["rng"] = (function () {
const U32=0x100000000;
function fill(buf){
const g=globalThis.crypto;
if(!g||typeof g.getRandomValues!=='function'){
throw new Error('df-rr: crypto.getRandomValues is required');
}
g.getRandomValues(buf);
}
function cryptoRng(){
const buf=new Uint32Array(1024);
let i=buf.length;
return{
nextUint32(){
if(i>=buf.length){fill(buf);i=0;}
return buf[i++]>>>0;
},
};
}
function randomSeed(){
const b=new Uint8Array(8);
fill(b);
let out='';
for(let i=0;i<b.length;i++)out+=b[i].toString(16).padStart(2,'0');
return out;
}
function mix(str){
let h=1779033703^str.length;
for(let i=0;i<str.length;i++){
h=Math.imul(h^str.charCodeAt(i),3432918353);
h=(h<<13)|(h>>>19);
}
return()=>{
h=Math.imul(h^(h>>>16),2246822507);
h=Math.imul(h^(h>>>13),3266489909);
h^=h>>>16;
return h>>>0;
};
}
function seededRng(seed){
const next=mix(String(seed));
let ah=next(),al=next(),bh=next(),bl=next();
if((ah|al|bh|bl)===0){ah=1;bl=1;}
return{
nextUint32(){
let s1h=ah,s1l=al;
const s0h=bh,s0l=bl;
const lsum=(s0l>>>0)+(s1l>>>0);
const rh=(s0h+s1h+(lsum>0xffffffff?1:0))>>>0;
ah=s0h;al=s0l;
const shh=((s1h<<23)|(s1l>>>9))>>>0;
const shl=(s1l<<23)>>>0;
s1h=(s1h^shh)>>>0;s1l=(s1l^shl)>>>0;
const a18h=s1h>>>18,a18l=((s1l>>>18)|(s1h<<14))>>>0;
const b5h=s0h>>>5,b5l=((s0l>>>5)|(s0h<<27))>>>0;
bh=(s1h^s0h^a18h^b5h)>>>0;
bl=(s1l^s0l^a18l^b5l)>>>0;
return rh;
},
};
}
function rngFor(seed){
return seed?seededRng(seed):cryptoRng();
}
function below(n,rng){
const m=Math.floor(n);
if(!(m>0)||!Number.isFinite(m))throw new Error('df-rr: below(n) needs n > 0');
const limit=U32-(U32%m);
let v;
do{v=rng.nextUint32();}while(v>=limit);
return v%m;
}
function coin(rng){
return(rng.nextUint32()&1)===1;
}

return { "cryptoRng": cryptoRng, "randomSeed": randomSeed, "seededRng": seededRng, "rngFor": rngFor, "below": below, "coin": coin };
})();

__m["shuffle"] = (function () {
const{below}=__m["rng"];
function shuffle(cards,rng){
const out=Array.prototype.slice.call(cards);
for(let i=out.length-1;i>0;i--){
const j=below(i+1,rng);
const t=out[i];
out[i]=out[j];
out[j]=t;
}
return out;
}

return { "shuffle": shuffle };
})();

__m["draw"] = (function () {
const{CARD_IDS}=__m["cards"];
const MAJOR_IDS=Object.freeze(CARD_IDS.slice(0,22));
function poolFor(deck){return deck==='marseille'?MAJOR_IDS:CARD_IDS;}
const{shuffle}=__m["shuffle"];
const{seededRng,randomSeed,coin}=__m["rng"];
const DECK_IDS=Object.freeze(['sunlight','moonlight','moonlight-gold','moon-magic',
'pink-moon','vintage-borderless','marseille']);
const SPREAD_IDS=Object.freeze(['one-card','past-present-future','situation-obstacle-advice',
'love-five','celtic-cross','yes-no','croix','trois']);
const DECK_SET=(()=>{const m=Object.create(null);for(const d of DECK_IDS)m[d]=1;return m;})();
const SPREAD_SET=(()=>{const m=Object.create(null);for(const s of SPREAD_IDS)m[s]=1;return m;})();
function isDeckId(id){return typeof id==='string'&&DECK_SET[id]===1;}
function isSpreadId(id){return typeof id==='string'&&SPREAD_SET[id]===1;}
function isSeed(s){return typeof s==='string'&& /^[0-9a-f]{1,16}$/.test(s);}
function fan(seed,deck){
if(!isSeed(seed))throw new TypeError('df-rr: a seed is 1-16 lowercase hex characters');
return shuffle(poolFor(deck),seededRng(seed));
}
function checkSpread(spread){
if(!spread||typeof spread!=='object')throw new TypeError('df-rr: draw needs a spread object');
if(!isSpreadId(spread.spread_id))throw new RangeError('df-rr: unknown spread_id');
const count=spread.count;
if(!Number.isInteger(count)||count<1||count>78)throw new RangeError('df-rr: spread count out of range');
if(!Array.isArray(spread.positions)||spread.positions.length!==count){
throw new RangeError('df-rr: spread count and positions disagree');
}
return count;
}
function checkPicks(picks,count,max){
const top=max===undefined?77:max-1;
if(!Array.isArray(picks)||picks.length!==count)throw new RangeError('df-rr: picks must match the spread count');
const seen=Object.create(null);
for(const p of picks){
if(!Number.isInteger(p)||p<0||p>top)throw new RangeError('df-rr: a pick is a fan slot 0-77');
if(seen[p])throw new RangeError('df-rr: the same fan slot was picked twice');
seen[p]=1;
}
return picks;
}
function reversalsDefault(data){
return!!(data&&data.flags&&data.flags.reversals_default===true);
}
function draw(spread,deck,opts){
const o=opts||{};
const count=checkSpread(spread);
if(!isDeckId(deck))throw new RangeError('df-rr: unknown deck_id');
const reversals=o.reversals===undefined?false:!!o.reversals;
let seed=o.seed;
let rng=o.rng;
let replayable=true;
if(rng){
replayable=false;
seed=isSeed(seed)?seed:'0';
}else{
if(seed!==undefined&&!isSeed(seed))throw new TypeError('df-rr: a seed is 1-16 lowercase hex characters');
if(seed===undefined)seed=randomSeed();
rng=seededRng(seed);
}
const pool=poolFor(deck);
const order=shuffle(pool,rng);
let picks;
if(o.picks===undefined){
picks=[];
for(let i=0;i<count;i++)picks.push(i);
}else{
picks=checkPicks(o.picks,count,pool.length);
for(let i=0;i<count;i++)if(picks[i]!==i){replayable=false;break;}
}
const cards=[];
for(let i=0;i<count;i++){
cards.push({
card_id:order[picks[i]],
reversed:reversals?coin(rng):false,
position:i,
});
}
return{seed,spread:spread.spread_id,deck,reversals,replayable,cards};
}

return { "MAJOR_IDS": MAJOR_IDS, "poolFor": poolFor, "DECK_IDS": DECK_IDS, "SPREAD_IDS": SPREAD_IDS, "isDeckId": isDeckId, "isSpreadId": isSpreadId, "isSeed": isSeed, "fan": fan, "reversalsDefault": reversalsDefault, "draw": draw };
})();

__m["lean"] = (function () {
const{isCardId}=__m["cards"];
const{own}=__m["text"];
const VERDICTS=Object.freeze(['yes','no','not-as-asked','unclear']);
const VERDICT_SET=(()=>{const m=Object.create(null);for(const v of VERDICTS)m[v]=1;return m;})();
function isVerdict(v){return typeof v==='string'&&VERDICT_SET[v]===1;}
const WB='\\b';
const WORD_CHAR= /[A-Za-z0-9_]/;
function edge(term,leading){
const ch=leading?term.charAt(0):term.charAt(term.length-1);
return WORD_CHAR.test(ch)?WB:'';
}
const COMBINING= /\p{M}/gu;
function fold(s){
if(typeof s!=='string')return'';
return s.normalize('NFD').replace(COMBINING,'').toLowerCase();
}
function escapeRegExp(s){
return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
}
function wordListHit(q,list){
return wordListScore(q,list)>0;
}
function wordListScore(q,list){
if(!Array.isArray(list))return 0;
const fq=fold(q);
let best=0;
for(const w of list){
if(typeof w!=='string'||w==='')continue;
const lw=fold(w);
if(lw===''||lw.length<=best)continue;
const re=new RegExp(edge(lw,true)+escapeRegExp(lw)+edge(lw,false));
if(re.test(fq))best=lw.length;
}
return best;
}
function isDecisionQuestion(text,data){
if(typeof text!=='string'||text==='')return false;
const q=text.trim().toLowerCase();
const s=(data&&data.strings)||{};
const openWords=s.question_open_words;
const fq=fold(q);
if(Array.isArray(openWords)){
for(const w of openWords){
if(typeof w==='string'&&w!==''&&fq.indexOf(fold(w))===0)return false;
}
}
return wordListHit(q,s.decision_hints);
}
function classifyTopic(text,data){
if(typeof text!=='string'||text==='')return null;
const q=text.trim().toLowerCase();
const s=(data&&data.strings)||{};
const love=wordListScore(q,s.topic_words_love);
const work=wordListScore(q,s.topic_words_work);
if(love>0||work>0)return work>love?'work':'love';
if(isDecisionQuestion(text,data))return'decision';
return null;
}
const TOPICS=Object.freeze(['love','work','decision','self']);
const TOPIC_SET=(()=>{const m=Object.create(null);for(const t of TOPICS)m[t]=1;return m;})();
function isTopic(v){return typeof v==='string'&&TOPIC_SET[v]===1;}
const MIN_QUESTION=4;
function needsTopic(text,data){
if(typeof text!=='string')return false;
const t=text.trim();
if(t==='')return false;
if(t.length<MIN_QUESTION)return true;
return classifyTopic(t,data)===null;
}
function verdictOf(card,data){
if(!isCardId(card.card_id))return null;
const c=own(data.cards,card.card_id);
if(!c)return null;
const v=card.reversed?c.yes_no_rev:c.yes_no_up;
if(!isVerdict(v))return null;
const reason=card.reversed?c.yes_no_reason_rev_plain:c.yes_no_reason_up;
return{verdict:v,reason:typeof reason==='string'&&reason.trim()!==''?reason:null};
}
function lean(drawn,data,opts){
const o=opts||{};
if(!drawn||!Array.isArray(drawn.cards)||!data)return null;
if(!o.force&&!isDecisionQuestion(o.question,data))return null;
const votes=[];
drawn.cards.forEach((card,i)=>{
const v=verdictOf(card,data);
if(v){
const position=Number.isInteger(card.position)?card.position:i;
votes.push({position,card_id:card.card_id,verdict:v.verdict,reason:v.reason});
}
});
if(votes.length===0)return null;
votes.sort((a,b)=>a.position-b.position);
const tally=Object.create(null);
for(const v of votes)tally[v.verdict]=(tally[v.verdict]||0)+1;
let top=0;
for(const v of VERDICTS)if((tally[v]||0)>top)top=tally[v]||0;
const tied=VERDICTS.filter((v)=>(tally[v]||0)===top);
let winner=tied[0];
if(tied.length>1){
for(let i=votes.length-1;i>=0;i--){
if(tied.indexOf(votes[i].verdict)!==-1){winner=votes[i].verdict;break;}
}
}
let deciding=null;
for(let i=votes.length-1;i>=0;i--){
if(votes[i].verdict===winner){deciding=votes[i];break;}
}
return{
verdict:winner,
why:deciding&&deciding.reason?deciding.reason:null,
counted:votes.length,
deciding:deciding?{card_id:deciding.card_id,position:deciding.position}:null,
};
}

return { "VERDICTS": VERDICTS, "isDecisionQuestion": isDecisionQuestion, "classifyTopic": classifyTopic, "TOPICS": TOPICS, "isTopic": isTopic, "MIN_QUESTION": MIN_QUESTION, "needsTopic": needsTopic, "lean": lean };
})();

__m["notices"] = (function () {
const{isCardId,arcanaOf,suitOf,numberOf,isCourt,isAce,SUITS}=__m["cards"];
const{own,str,fill}=__m["text"];
const NOTICE_KINDS=Object.freeze(['majors','suit','courts','aces','reversals','repeats']);
function push(out,kind,tpls,vars){
const text=fill(own(tpls,kind),vars);
const means=fill(own(tpls,kind+'_means'),vars);
if(text&&means)out.push({kind,text,means});
}
function notices(drawn,data){
const out=[];
if(!drawn||!Array.isArray(drawn.cards)||!data)return out;
const tpls=data.strings&&data.strings.notices;
if(!tpls||typeof tpls!=='object')return out;
const cards=drawn.cards
.map((c,i)=>({c,pos:Number.isInteger(c&&c.position)?c.position:i}))
.filter((x)=>x.c&&isCardId(x.c.card_id))
.sort((a,b)=>a.pos-b.pos)
.map((x)=>x.c);
const total=cards.length;
if(total===0)return out;
let majors=0,courts=0,aces=0,reversed=0;
const suitCount=Object.create(null);
const numberCount=Object.create(null);
const suitElement=Object.create(null);
for(const c of cards){
const id=c.card_id;
if(arcanaOf(id)==='major')majors++;
if(isCourt(id))courts++;
if(isAce(id))aces++;
if(c.reversed)reversed++;
const suit=suitOf(id);
if(suit){
suitCount[suit]=(suitCount[suit]||0)+1;
if(!suitElement[suit]){
const el=str(own(own(data.cards,id)||{},'element'));
if(el)suitElement[suit]=el;
}
}
if(!isCourt(id)){
const n=numberOf(id);
numberCount[n]=(numberCount[n]||0)+1;
}
}
if(majors>0)push(out,'majors',tpls,{count:majors,total});
let best=null,bestN=1,tied=false;
for(const s of SUITS){
const n=suitCount[s]||0;
if(n>bestN){best=s;bestN=n;tied=false;}else if(n===bestN&&n>1){tied=true;}
}
if(best&&!tied){
const label=str(own(data.strings&&data.strings.suits,best));
push(out,'suit',tpls,{suit:label,element:suitElement[best],count:bestN,total});
}
if(courts>0)push(out,'courts',tpls,{count:courts,total});
if(aces>0)push(out,'aces',tpls,{count:aces,total});
if(reversed>0)push(out,'reversals',tpls,{count:reversed,total});
let repN=null,repC=1;
for(const k of Object.keys(numberCount)){
const n=Number(k),c=numberCount[k];
if(c>repC||(c===repC&&c>1&&n<repN)){repN=n;repC=c;}
}
if(repN!==null&&repC>1)push(out,'repeats',tpls,{number:repN,count:repC,total});
return out;
}

return { "NOTICE_KINDS": NOTICE_KINDS, "notices": notices };
})();

__m["yesno"] = (function () {
const{isCardId,cardIndex}=__m["cards"];
const{own,str,stripLeadingLabel,normalizeSafetyText,windowMatch}=__m["text"];
const{VERDICTS,classifyTopic,isTopic}=__m["lean"];
const VERDICT_SET=(()=>{const m=Object.create(null);for(const v of VERDICTS)m[v]=1;return m;})();
const RISK_WARNED=new WeakSet();
function warnNoRiskTerms(data){
if(!data||RISK_WARNED.has(data))return;
RISK_WARNED.add(data);
if(globalThis.console&&globalThis.console.warn){
globalThis.console.warn('[df-rr] soft guard has no risk_terms');
}
}
function pickLookQ(card,id,reversed){
const list=own(card,'look_q');
if(!Array.isArray(list)||list.length===0)return null;
const i=(cardIndex(id)+(reversed?1:0))%list.length;
return str(list[i]);
}
function yesNo(card,reversed,data,question,opts){
const id=typeof card==='string'?card:(card&&card.card_id);
if(!isCardId(id)||!data)return null;
const c=own(data.cards,id);
if(!c)return null;
const rev=!!reversed;
const v=rev?c.yes_no_rev:c.yes_no_up;
const verdict=typeof v==='string'&&VERDICT_SET[v]===1?v:null;
const o=opts||{};
const topic=isTopic(o.topic)?o.topic:classifyTopic(question,data);
const topicLineField=topic==='love'?(rev?'love_rev':'love_line')
:topic==='work'?(rev?'work_rev':'work_line'):null;
const reasonRaw=(topicLineField&&str(own(c,topicLineField)))
||str(rev?c.yes_no_reason_rev:c.yes_no_reason_up);
const verdictLabel=verdict&&data.strings&&own(data.strings.verdict,verdict);
const reason=stripLeadingLabel(reasonRaw,typeof verdictLabel==='string'?verdictLabel:null);
const practiceField=topic==='love'?'practice_love':topic==='work'?'practice_work'
:topic==='decision'?'practice_decision':topic==='self'?'practice_self':null;
const action=(practiceField&&str(own(c,practiceField)))||str(c.practice);
return{
verdict,
reason,
look_q:pickLookQ(c,id,rev),
action,
topic:isTopic(topic)?topic:null,
};
}
function safetyGuardInert(data){
const s=data&&data.strings;
if(!s||typeof s!=='object')return true;
const flag=s.safety_terms_inert;
if(flag!==undefined&&flag!==null){
if(flag===true)return true;
if(flag!==false){
const f=typeof flag==='string'?flag.trim().toLowerCase():null;
if(f!=='ready')return true;
}
}
const terms=s.safety_terms;
if(!Array.isArray(terms)||terms.length===0)return true;
const listLang=str(s.safety_terms_lang);
const pageLang=str(data.lang);
if(listLang&&pageLang&&listLang!==pageLang)return true;
return false;
}
function safetyHelpText(data){
const t=str(data&&data.strings&&data.strings.safety_help);
if(!t)return null;
return /\[\[[^\]]*\]\]/.test(t)?null:t;
}
const ALLOWED_HREF_SCHEME= /^(https:\/\/|tel:)/;
function safetyHelpLinks(data){
const raw=data&&data.strings&&data.strings.safety_help_links;
if(!Array.isArray(raw))return[];
return raw.filter((l)=>l&&typeof l.text==='string'&&l.text!==''
&&typeof l.href==='string'&&ALLOWED_HREF_SCHEME.test(l.href));
}
const COMBINING= /[̀-ͯ]/g;
function norm(s,data){
const n=normalizeSafetyText(s);
return data&&data.lang==='fr'
?n.normalize('NFD').replace(COMBINING,'').replace(/œ/g,'oe').replace(/æ/g,'ae')
:n;
}
function isSafetyQuestion(text,data){
if(typeof text!=='string'||text==='')return false;
const terms=data&&data.strings&&data.strings.safety_terms;
if(!Array.isArray(terms)||terms.length===0)return false;
let q=norm(text,data);
if(q==='')return false;
q=stripKnownPhrases(q,[data.strings.safety_exclude_terms],data);
for(const t of terms){
if(typeof t!=='string'||t==='')continue;
const nt=norm(t,data);
if(nt==='')continue;
if(q.indexOf(nt)!==-1)return true;
if(windowMatch(q,nt))return true;
}
return false;
}
function stripKnownPhrases(q,lists,data){
for(const list of lists){
if(!Array.isArray(list))continue;
for(const phrase of list){
if(typeof phrase!=='string'||phrase==='')continue;
const normalized=norm(phrase,data);
if(normalized==='')continue;
q=q.split(normalized).join(' ');
}
}
return q;
}
function isRiskQuestion(text,data){
if(typeof text!=='string'||text==='')return false;
const terms=data&&data.strings&&data.strings.risk_terms;
if(!Array.isArray(terms)||terms.length===0){
warnNoRiskTerms(data);
return false;
}
let q=norm(text,data);
if(q==='')return false;
q=stripKnownPhrases(q,[data.strings.death_card_terms,data.strings.risk_exclude_terms],data);
if(q.trim()==='')return false;
for(const t of terms){
if(typeof t!=='string'||t==='')continue;
const nt=norm(t,data);
if(nt==='')continue;
if(q.indexOf(nt)!==-1)return true;
if(windowMatch(q,nt))return true;
}
return false;
}
function riskResponse(question,data){
const typed=str(question);
if(!typed)return null;
const s=(data&&data.strings)||{};
if(!isRiskQuestion(typed,data))return null;
return{kind:'risk',text:safetyHelpText(data),lang:str(s.safety_help_lang)||'en',links:safetyHelpLinks(data)};
}
function safetyResponse(question,data){
const typed=str(question);
if(!typed)return null;
const s=(data&&data.strings)||{};
if(isSafetyQuestion(typed,data)){
return{kind:'crisis',text:safetyHelpText(data),lang:str(s.safety_help_lang)||'en',links:safetyHelpLinks(data)};
}
if(safetyGuardInert(data)){
const raw=str(s.safety_guard_unavailable);
const text=raw&&!/\[\[[^\]]*\]\]/.test(raw)?raw:null;
return{kind:'unavailable',text,lang:str(s.safety_guard_unavailable_lang)||'en'};
}
return null;
}

return { "yesNo": yesNo, "safetyGuardInert": safetyGuardInert, "safetyHelpText": safetyHelpText, "safetyHelpLinks": safetyHelpLinks, "isSafetyQuestion": isSafetyQuestion, "isRiskQuestion": isRiskQuestion, "riskResponse": riskResponse, "safetyResponse": safetyResponse };
})();

__m["compose"] = (function () {
const{isCardId}=__m["cards"];
const{own,str,fill,stripLeadingLabel}=__m["text"];
const{lean:computeLean,classifyTopic,isTopic}=__m["lean"];
const{notices}=__m["notices"];
const{isDeckId,isSpreadId}=__m["draw"];
const LANGS=Object.freeze(['en','de','fr','it','es','ja']);
const LANG_SET=(()=>{const m=Object.create(null);for(const l of LANGS)m[l]=1;return m;})();
const SCHEMA_VERSION=1;
function localPath(v){
const s=str(v);
if(!s||s.charCodeAt(0)!==47)return null;
if(s.charCodeAt(1)===47)return null;
return /[\s"'<>\\]/.test(s)?null:s;
}
const LENS_FIELD={love:'love_q',work:'work_q',decision:'decision_q'};
function spreadOf(drawn,data){
for(const s of(data.spreads||[]))if(s&&s.spread_id===drawn.spread)return s;
return null;
}
function pickFrom(list,i){
if(!Array.isArray(list)||list.length===0)return null;
return str(list[((i%list.length)+list.length)%list.length]);
}
function withoutEcho(body,meaning){
if(!body||!meaning)return body;
if(body===meaning)return null;
if(body.slice(0,meaning.length)!==meaning)return body;
return str(body.slice(meaning.length));
}
function compose(drawn,data,opts){
const o=opts||{};
if(!drawn||!Array.isArray(drawn.cards))throw new TypeError('df-rr: compose needs a drawn object');
if(!data||typeof data!=='object')throw new TypeError('df-rr: compose needs a page data block');
if(data.v!==SCHEMA_VERSION)throw new RangeError('df-rr: unknown page-data version '+data.v);
if(typeof data.lang!=='string'||LANG_SET[data.lang]!==1)throw new RangeError('df-rr: unknown lang');
if(!isSpreadId(drawn.spread))throw new RangeError('df-rr: unknown spread_id');
if(!isDeckId(drawn.deck))throw new RangeError('df-rr: unknown deck_id');
const spread=spreadOf(drawn,data);
const positionsIn=(spread&&Array.isArray(spread.positions))?spread.positions:[];
const strings=(data.strings&&typeof data.strings==='object')?data.strings:{};
const lensField=own(LENS_FIELD,spread?spread.question_type:'');
const topic=isTopic(o.topic)?o.topic:classifyTopic(o.question,data);
const topicLineField=topic==='love'?'love':topic==='work'?'work':null;
const topicOneField=topic==='decision'?'decision_q':topic==='self'?'self_q':null;
let centralPos=0;
for(let i=0;i<positionsIn.length;i++)if(positionsIn[i]&&positionsIn[i].central===true){centralPos=i;break;}
const cards=drawn.cards
.map((c,i)=>({c,pos:Number.isInteger(c&&c.position)?c.position:i}))
.sort((a,b)=>a.pos-b.pos);
const out=[];
let glossUsed=false;
cards.forEach(({c,pos})=>{
if(!c||!isCardId(c.card_id))return;
const card=own(data.cards,c.card_id);
if(!card)return;
const p=positionsIn[pos]||{};
const reversed=!!c.reversed;
let gloss=null;
if(reversed&&!glossUsed){
gloss=str(card.orientation_gloss);
if(gloss)glossUsed=true;
}
const posKey=str(p.key)||String(pos);
const byPos=!reversed?str(own(own(card,'by_position')||{},posKey)):null;
out.push({
key:posKey,
asks:str(p.asks),
...(str(p.note)?{note:str(p.note)}:{}),
card_id:c.card_id,
reversed,
name:str(card.name),
meaning:str(reversed?card.common_meaning_rev:card.common_meaning),
gloss,
body:withoutEcho(
(topicLineField&&str(own(card,topicLineField+(reversed?'_rev':'_line'))))
||(topicOneField&&str(own(card,topicOneField)))
||byPos
||str(reversed?card.core_rev_plain:card.core_up),
str(reversed?card.common_meaning_rev:card.common_meaning)),
lens:lensField?str(own(card,lensField)):null,
look_q:null,
});
});
const universal=[];
cards.forEach(({c,pos})=>{
const card=own(data.cards,c&&c.card_id);
if(!card)return;
const list=Array.isArray(card.look_q)?card.look_q:[];
const flags=Array.isArray(card.look_q_universal)?card.look_q_universal:[];
for(let k=0;k<list.length;k++){
if(flags[k]!==true)continue;
const q=str(list[k]);
if(q)universal.push({pos,q});
}
});
const spare=[];
let shown=false;
for(const u of universal){
if(!shown){
const block=out.find((x)=>x.card_id===(cards.find((y)=>y.pos===u.pos)||{}).c.card_id);
if(block){block.look_q=u.q;shown=true;continue;}
}
if(spare.indexOf(u.q)===-1)spare.push(u.q);
}
const leanRaw=computeLean(drawn,data,{question:o.question});
let headline=null;
let leanWhy=null;
if(leanRaw){
const verdictLabel=own(strings.verdict,leanRaw.verdict);
leanWhy=stripLeadingLabel(leanRaw.why,typeof verdictLabel==='string'?verdictLabel:null);
headline=fill(own(strings.lean,leanRaw.verdict),{thing:leanWhy});
}
let onlyMeaning=null;
if(!headline){
const single=out.length===1?out[0]:null;
const meanings=(single&&(topicLineField||topicOneField)&&single.body)
?[single.body]
:out.map((p)=>p.meaning).filter(Boolean).slice(0,3);
const meaning=meanings.length?meanings.join(' '):null;
if(single&&meanings.length===1)onlyMeaning=meanings[0];
const pointTpl=out.length>1?(str(strings.point_plural)||strings.point):strings.point;
headline=fill(pointTpl,{spread:str(spread&&spread.name),meaning})
||str(spread&&spread.intro)
||meaning;
}
for(const p of out){
if(p.meaning&&p.meaning===onlyMeaning)p.meaning=null;
}
const centralEntry=cards.find((x)=>x.pos===centralPos)||cards[0];
const centralDrawn=centralEntry?centralEntry.c:null;
const centralData=centralDrawn&&isCardId(centralDrawn.card_id)?own(data.cards,centralDrawn.card_id):null;
const topicField=topic==='love'?'practice_love':topic==='work'?'practice_work'
:topic==='decision'?'practice_decision':topic==='self'?'practice_self':null;
const action=centralData
?(topicField&&str(own(centralData,topicField)))||str(centralData.practice)
:null;
const misreadField=topic==='love'?'misread_love':topic==='work'?'misread_work'
:topic==='decision'?'misread_decision':topic==='self'?'misread_self':null;
const caveatOf=(card)=>{
if(!card)return null;
const own_=misreadField?str(own(card,misreadField)):null;
if(own_)return own_;
const belongs=str(card.misread_topic);
if(topic&&belongs&&belongs!==topic)return null;
return str(card.misread);
};
let notSaying=caveatOf(centralData);
if(!notSaying){
for(const entry of cards){
if(!entry||!entry.c||entry===centralEntry)continue;
const alt=caveatOf(own(data.cards,entry.c.card_id));
if(alt){notSaying=alt;break;}
}
}
const LONG_SPREAD_MIN=5;
const longPositions=[];
if(positionsIn.length>=LONG_SPREAD_MIN){
for(const p of out){
if(p.asks||p.lens)longPositions.push({key:p.key,name:p.name,asks:p.asks,lens:p.lens});
p.asks=null;
p.lens=null;
}
}
const noticeList=notices(drawn,data);
const prompt=str(strings.yourself_prompt);
const askQ=centralData?pickFrom(centralData.ask_q,centralPos):null;
const yourself=(prompt||askQ||spare.length||noticeList.length||longPositions.length)
?{prompt,ask_q:askQ,look_q:spare,notices:noticeList,positions:longPositions}
:null;
const learn=[];
const cardTpl=own(strings.learn,'card');
const seenPair=Object.create(null);
for(const p of out){
const card=own(data.cards,p.card_id);
const url=localPath(card&&card.article_url);
const label=fill(cardTpl,{name:p.name});
const pair=label+'\u0000'+url;
if(url&&label&&!seenPair[pair]){seenPair[pair]=1;learn.push({label,url});}
}
for(const key of['spread','all']){
const link=own(strings.learn,key);
if(link&&typeof link==='object'){
const label=str(link.label);
const url=localPath(link.url);
const pair=label+'\u0000'+url;
if(label&&url&&!seenPair[pair]){seenPair[pair]=1;learn.push({label,url});}
}
}
return{
spread:drawn.spread,
deck:drawn.deck,
lang:data.lang,
seed:drawn.seed,
lean:leanRaw?{verdict:leanRaw.verdict,why:leanWhy}:null,
topic:isTopic(topic)?topic:null,
headline,
positions:out,
not_saying:notSaying,
action,
yourself,
learn,
caution_line:str(strings.caution),
};
}

return { "LANGS": LANGS, "SCHEMA_VERSION": SCHEMA_VERSION, "localPath": localPath, "compose": compose };
})();

__m["daily"] = (function () {
const{CARD_IDS,isCardId}=__m["cards"];
const{isDeckId,reversalsDefault}=__m["draw"];
const{cryptoRng,below,coin}=__m["rng"];
const DATE_RE= /^(\d{4})-(\d{2})-(\d{2})$/;
function isLocalDate(s){
if(typeof s!=='string')return false;
const m=DATE_RE.exec(s);
if(!m)return false;
const y=+m[1],mo=+m[2],d=+m[3];
if(mo<1||mo>12||d<1||d>31)return false;
const dt=new Date(y,mo-1,d);
return dt.getFullYear()===y&&dt.getMonth()===mo-1&&dt.getDate()===d;
}
function localDate(date){
const d=date instanceof Date?date:new Date();
const p=(n)=>String(n).padStart(2,'0');
return`${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
function usable(stored,date){
return!!stored
&&typeof stored==='object'
&&!Array.isArray(stored)
&&stored.date===date
&&isLocalDate(stored.date)
&&isCardId(stored.card_id)
&&typeof stored.reversed==='boolean';
}
function daily(date,deck,data,opts){
const o=opts||{};
if(!isLocalDate(date))throw new TypeError('df-rr: daily needs a local date as YYYY-MM-DD');
if(!isDeckId(deck))throw new RangeError('df-rr: unknown deck_id');
if(usable(o.stored,date)){
return{date,card_id:o.stored.card_id,reversed:o.stored.reversed,fresh:false};
}
const rng=o.rng||cryptoRng();
const reversalsOn=reversalsDefault(data);
return{
date,
card_id:CARD_IDS[below(CARD_IDS.length,rng)],
reversed:reversalsOn?coin(rng):false,
fresh:true,
};
}

return { "isLocalDate": isLocalDate, "localDate": localDate, "daily": daily };
})();

__m["birth-cards"] = (function () {
const{checkDate}=__m["dates"];
function fold(n){
return Math.floor(n / 10)+(n%10);
}
function birthCards(year,month,day){
checkDate(year,month,day,'birthCards');
let sum=month+day+Math.floor(year / 100)+(year%100);
while(sum>99)sum=fold(sum);
let primary=sum;
if(primary>21)primary=fold(primary);
let secondary=primary>9?fold(primary):null;
let tertiary=null;
if(primary===19){secondary=10;tertiary=1;}
return{primary,secondary,tertiary};
}
function idOf(n){
return n===null?null:'major-'+String(n).padStart(2,'0');
}
function birthCardIds(year,month,day){
const r=birthCards(year,month,day);
return{primary:idOf(r.primary),secondary:idOf(r.secondary),tertiary:idOf(r.tertiary)};
}
function birthCardSteps(year,month,day){
checkDate(year,month,day,'birthCards');
const century=Math.floor(year / 100);
const inCentury=year%100;
let sum=month+day+century+inCentury;
const steps=[{kind:'add',parts:[month,day,century,inCentury],to:sum}];
while(sum>99){
const to=fold(sum);
steps.push({kind:'fold',from:sum,a:Math.floor(sum / 10),b:sum%10,to});
sum=to;
}
if(sum>21){
const to=fold(sum);
steps.push({kind:'fold',from:sum,a:Math.floor(sum / 10),b:sum%10,to});
}
return steps;
}

return { "birthCards": birthCards, "birthCardIds": birthCardIds, "birthCardSteps": birthCardSteps };
})();

__m["personal-year"] = (function () {
const{checkDate,daysInMonth}=__m["dates"];
const YEAR_CARD_RANGE=Object.freeze({min:5,max:17});
function digitSum(n){
let s=0;
while(n>0){s+=n%10;n=Math.floor(n / 10);}
return s;
}
function yearCard(month,day,year){
if(!Number.isInteger(year)||year<1||year>9999){
throw new Error('yearCard: calendar year must be an integer 1..9999');
}
if(!Number.isInteger(month)||!Number.isInteger(day)||month<1||month>12
||day<1||day>daysInMonth(2024,month)){
throw new Error('yearCard: not a real month/day pair');
}
checkDate(year,1,1,'yearCard');
let sum=month+day+year;
while(sum>22)sum=digitSum(sum);
return{
number:sum,
card_id:'major-'+String(sum%22).padStart(2,'0'),
roman:roman(sum),
};
}
const ROMAN=['0','I','II','III','IV','V','VI','VII','VIII','IX','X','XI',
'XII','XIII','XIV','XV','XVI','XVII','XVIII','XIX','XX','XXI','XXII'];
function roman(n){
return(Number.isInteger(n)&&n>=0&&n<ROMAN.length)?ROMAN[n]:null;
}
function inWrittenRange(n){
return Number.isInteger(n)&&n>=YEAR_CARD_RANGE.min&&n<=YEAR_CARD_RANGE.max;
}

return { "YEAR_CARD_RANGE": YEAR_CARD_RANGE, "yearCard": yearCard, "roman": roman, "inWrittenRange": inWrittenRange };
})();

__m["life-path"] = (function () {
const{checkDate}=__m["dates"];
const LIFE_PATH_NUMBERS=Object.freeze([1,2,3,4,5,6,7,8,9,11,22]);
function digitSum(n){
let s=0;
while(n>0){s+=n%10;n=Math.floor(n / 10);}
return s;
}
function reduce(n){
while(n>9&&n!==11&&n!==22)n=digitSum(n);
return n;
}
function lifePath(year,month,day){
checkDate(year,month,day,'lifePath');
const total=reduce(month)+reduce(day)+reduce(digitSum(year));
const number=reduce(total);
return{number,card_id:'major-'+String(number%22).padStart(2,'0')};
}

return { "LIFE_PATH_NUMBERS": LIFE_PATH_NUMBERS, "lifePath": lifePath };
})();

__m["serialise"] = (function () {
const{draw,isDeckId,isSpreadId,isSeed,reversalsDefault}=__m["draw"];
const{compose,LANGS}=__m["compose"];
const LANG_SET=(()=>{const m=Object.create(null);for(const l of LANGS)m[l]=1;return m;})();
const CODE_RE= /^([0-9a-f]{1,16})\.([a-z][a-z0-9-]{0,31})\.([a-z][a-z0-9-]{0,31})\.([a-z]{2})$/;
function parseCode(code){
if(typeof code!=='string'||code.length>64)return null;
const m=CODE_RE.exec(code);
if(!m)return null;
const[,seed,spread,deck,lang]=m;
if(!isSeed(seed)||!isSpreadId(spread)||!isDeckId(deck)||LANG_SET[lang]!==1)return null;
return{seed,spread,deck,lang};
}
function serialise(reading,opts){
const o=opts||{};
if(!reading||typeof reading!=='object')return null;
if(reading.replayable===false)return null;
if(o.drawn&&o.drawn.replayable===false)return null;
if(o.replayable===false)return null;
const{seed,spread,deck}=reading;
const lang=typeof reading.lang==='string'?reading.lang:o.lang;
if(!isSeed(seed)||!isSpreadId(spread)||!isDeckId(deck))return null;
if(typeof lang!=='string'||LANG_SET[lang]!==1)return null;
return`${seed}.${spread}.${deck}.${lang}`;
}
function restore(code,data){
const parsed=parseCode(code);
if(!parsed||!data||typeof data!=='object')return null;
if(data.lang!==parsed.lang)return null;
const spread=(data.spreads||[]).find((s)=>s&&s.spread_id===parsed.spread);
if(!spread)return null;
const deck=(data.decks||[]).find((d)=>d&&d.deck_id===parsed.deck);
if(!deck)return null;
const reversals=reversalsDefault(data);
try{
return compose(draw(spread,parsed.deck,{seed:parsed.seed,reversals}),data);
}catch{
return null;
}
}

return { "parseCode": parseCode, "serialise": serialise, "restore": restore };
})();

__m["storage"] = (function () {
const NS='df.rr.v1.';
const KEY_RE= /^[a-z][a-z0-9-]{0,31}$/;
function backend(){
try{
const s=globalThis.localStorage;
if(!s)return null;
return s;
}catch{
return null;
}
}
function available(){
const s=backend();
if(!s)return false;
try{
const probe=NS+'__probe';
s.setItem(probe,'1');
s.removeItem(probe);
return true;
}catch{
return false;
}
}
function read(key){
if(!KEY_RE.test(key))return null;
const s=backend();
if(!s)return null;
try{
const raw=s.getItem(NS+key);
if(typeof raw!=='string'||raw==='')return null;
if(raw.length>8192)return null;
return JSON.parse(raw);
}catch{
return null;
}
}
function write(key,value){
if(!KEY_RE.test(key))return false;
const s=backend();
if(!s)return false;
try{
s.setItem(NS+key,JSON.stringify(value));
return true;
}catch{
return false;
}
}
function reversalsChoice(){
const v=read('reversals');
return typeof v==='boolean'?v:null;
}
function rememberReversals(on){
return write('reversals',!!on);
}
function remove(key){
if(!KEY_RE.test(key))return false;
const s=backend();
if(!s)return false;
try{
s.removeItem(NS+key);
return true;
}catch{
return false;
}
}
const SNS='df.rr.s1.';
function sessionBackend(){
try{
const s=globalThis.sessionStorage;
if(!s)return null;
return s;
}catch{
return null;
}
}
function readSession(key){
if(!KEY_RE.test(key))return null;
const s=sessionBackend();
if(!s)return null;
try{
const raw=s.getItem(SNS+key);
if(typeof raw!=='string'||raw==='')return null;
if(raw.length>8192)return null;
return JSON.parse(raw);
}catch{
return null;
}
}
function writeSession(key,value){
if(!KEY_RE.test(key))return false;
const s=sessionBackend();
if(!s)return false;
try{
s.setItem(SNS+key,JSON.stringify(value));
return true;
}catch{
return false;
}
}
function removeSession(key){
if(!KEY_RE.test(key))return false;
const s=sessionBackend();
if(!s)return false;
try{
s.removeItem(SNS+key);
return true;
}catch{
return false;
}
}
function rememberBirthDate(date){
const d=date||{};
if(!Number.isInteger(d.y)||!Number.isInteger(d.m)||!Number.isInteger(d.d))return false;
if(d.y<1||d.y>9999||d.m<1||d.m>12||d.d<1||d.d>31)return false;
return writeSession('birth',{y:d.y,m:d.m,d:d.d});
}
function birthDateRemembered(){
const v=readSession('birth');
if(!v||typeof v!=='object'||Array.isArray(v))return null;
const y=v.y,m=v.m,d=v.d;
if(!Number.isInteger(y)||!Number.isInteger(m)||!Number.isInteger(d))return null;
if(y<1||y>9999||m<1||m>12||d<1||d>31)return null;
return{y,m,d};
}
function returnedFromForm(search){
let q=search;
if(typeof q!=='string'){
try{q=(globalThis.location&&globalThis.location.search)||'';}catch{q='';}
}
if(typeof q!=='string'||q==='')return false;
const body=q.charCodeAt(0)===63?q.slice(1):q;
for(const part of body.split('&')){
const eq=part.indexOf('=');
const k=eq===-1?part:part.slice(0,eq);
if(k!=='customer_posted')continue;
const v=eq===-1?'':part.slice(eq+1);
return v===''||v==='true'||v==='1';
}
return false;
}

return { "NS": NS, "available": available, "read": read, "write": write, "reversalsChoice": reversalsChoice, "rememberReversals": rememberReversals, "remove": remove, "SNS": SNS, "readSession": readSession, "writeSession": writeSession, "removeSession": removeSession, "rememberBirthDate": rememberBirthDate, "birthDateRemembered": birthDateRemembered, "returnedFromForm": returnedFromForm };
})();

__m["dom"] = (function () {
const GRID=12;
function clampGrid(v){
const n=typeof v==='number'?v:Number(v);
if(!Number.isFinite(n))return GRID / 2;
return n<0?0:(n>GRID?GRID:n);
}
function clampRot(v){
const n=typeof v==='number'?v:Number(v);
if(!Number.isFinite(n))return 0;
return n<-360?-360:(n>360?360:n);
}
function prefersReducedMotion(){
try{
const mm=globalThis.matchMedia;
if(typeof mm!=='function')return false;
return!!mm.call(globalThis,'(prefers-reduced-motion: reduce)').matches;
}catch{
return false;
}
}
function doc(){
const d=globalThis.document;
if(!d)throw new Error('df-rr: no document');
return d;
}
function el(tag,opts,children){
const o=opts||{};
const node=doc().createElement(tag);
if(o.cls)node.setAttribute('class',o.cls);
if(o.attrs){
for(const k of Object.keys(o.attrs)){
const v=o.attrs[k];
if(v===null||v===undefined||v===false)continue;
node.setAttribute(k,String(v));
}
}
if(o.props)for(const k of Object.keys(o.props))node[k]=o.props[k];
if(o.on)for(const k of Object.keys(o.on))node.addEventListener(k,o.on[k]);
if(typeof o.text==='string'&&o.text!=='')node.textContent=o.text;
if(children){
for(const c of children){
if(c===null||c===undefined||c===false)continue;
node.appendChild(typeof c==='string'?doc().createTextNode(c):c);
}
}
return node;
}
function clear(node){
if(!node)return;
while(node.firstChild)node.removeChild(node.firstChild);
}
function line(tag,text,cls){
if(typeof text!=='string'||text.trim()==='')return null;
return el(tag,{text,cls});
}
const PHONE_SHAPED= /^[0-9-]+$/;
const DIGIT_OR_HYPHEN= /[0-9-]/;
function linkedChildren(text,links){
if(typeof text!=='string'||text.trim()==='')return null;
const list=Array.isArray(links)
?links.filter((l)=>l&&typeof l.text==='string'&&l.text!==''&&typeof l.href==='string'&&l.href!=='')
:[];
if(list.length===0)return[text];
const esc=(s)=>s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
const re=new RegExp(list.map((l)=>esc(l.text)).join('|'),'g');
const hrefOf=new Map(list.map((l)=>[l.text,l.href]));
const children=[];
let last=0;
let m=re.exec(text);
while(m!==null){
const matched=m[0];
const start=m.index;
const end=start+matched.length;
const unsafe=PHONE_SHAPED.test(matched)
&&((start>0&&DIGIT_OR_HYPHEN.test(text[start-1]))
||(end<text.length&&DIGIT_OR_HYPHEN.test(text[end])));
if(!unsafe){
if(start>last)children.push(text.slice(last,start));
children.push(el('a',{text:matched,attrs:{href:hrefOf.get(matched)}}));
last=end;
}
if(matched.length===0)re.lastIndex+=1;
m=re.exec(text);
}
if(last<text.length)children.push(text.slice(last));
return children.length?children:[text];
}
function linkedLine(tag,text,cls,links){
const kids=linkedChildren(text,links);
if(!kids)return null;
return el(tag,{cls},kids);
}
function focusTo(node){
if(!node||typeof node.focus!=='function')return;
try{
if(!node.hasAttribute||!node.hasAttribute('tabindex'))node.setAttribute('tabindex','-1');
node.focus();
}catch{}
}
function liveRegion(){
return el('p',{cls:'df-rr-sr',attrs:{'aria-live':'polite','aria-atomic':'true'}});
}
function busyNode(){
return el('div',{
cls:'df-rr-busy',
attrs:{role:'status','aria-busy':'true','aria-live':'polite'},
},[
el('span',{cls:'df-rr-busy__dot'}),
el('span',{cls:'df-rr-busy__dot'}),
el('span',{cls:'df-rr-busy__dot'}),
]);
}
function say(region,text){
if(region&&typeof text==='string')region.textContent=text;
}
function onKeyActivate(node,fn){
node.addEventListener('keydown',(e)=>{
if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){
if(typeof e.preventDefault==='function')e.preventDefault();
fn(e);
}
});
}

return { "GRID": GRID, "clampGrid": clampGrid, "clampRot": clampRot, "prefersReducedMotion": prefersReducedMotion, "el": el, "clear": clear, "line": line, "linkedChildren": linkedChildren, "linkedLine": linkedLine, "focusTo": focusTo, "liveRegion": liveRegion, "busyNode": busyNode, "say": say, "onKeyActivate": onKeyActivate };
})();

__m["prose"] = (function () {
const TARGET_WORDS=70;
function words(s){
return typeof s==='string'?(s.trim()===''?0:s.trim().split(/\s+/).length):0;
}
function sentences(text){
const out=[];
let start=0;
for(let i=0;i<text.length;i++){
const c=text[i];
if(c!=='.'&&c!=='!'&&c!=='?'&&c!=='。'&&c!=='！'&&c!=='？')continue;
let j=i+1;
while(j<text.length&&'"”’\')]」』'.indexOf(text[j])!==-1)j++;
const next=text[j];
if(next!==undefined&&!/\s/.test(next)&&c!=='。'&&c!=='！'&&c!=='？')continue;
const piece=text.slice(start,j).trim();
if(piece!=='')out.push(piece);
start=j;
i=j-1;
}
const tail=text.slice(start).trim();
if(tail!=='')out.push(tail);
return out;
}
function paragraphs(text,targetWords){
if(typeof text!=='string'||text.trim()==='')return[];
const target=Number.isInteger(targetWords)&&targetWords>0?targetWords:TARGET_WORDS;
const authored=text.split(/\n[ \t]*\n+/).map((p)=>p.replace(/\s+/g,' ').trim()).filter((p)=>p!=='');
if(authored.length>1)return authored;
const flat=text.replace(/\s+/g,' ').trim();
if(words(flat)<=target)return[flat];
const parts=sentences(flat);
if(parts.length<2)return[flat];
const out=[];
let buf=[];
let n=0;
for(let i=0;i<parts.length;i++){
buf.push(parts[i]);
n+=words(parts[i]);
const remaining=parts.slice(i+1).reduce((a,s)=>a+words(s),0);
if(n>=target&&remaining>=Math.ceil(target / 2)){
out.push(buf.join(' '));
buf=[];
n=0;
}
}
if(buf.length)out.push(buf.join(' '));
return out;
}

return { "TARGET_WORDS": TARGET_WORDS, "words": words, "paragraphs": paragraphs };
})();

__m["events"] = (function () {
const{DECK_IDS,SPREAD_IDS}=__m["draw"];
const{LANGS}=__m["compose"];
const EVENT_NAMES=Object.freeze([
'tool_view','deck_pick','spread_pick','draw_start','reveal','reading_end','learn_click',
'deck_offer_view','add_to_cart','email_submit','save_reading','share','flashcard_round_end',
'look_q_view','self_answer_open','why_open',
'ai_note_request','ai_note_shown','ai_note_blocked','ai_note_error',
'year_card_view',
]);
const TOOLS=Object.freeze([
'table','yes-no','daily','birth-cards',
'library','card-block','spreads','learn','deck-finder','life-path',
]);
const BLOCK_REASONS=Object.freeze(['limit','safety','filter','quota']);
function set(list){const m=Object.create(null);for(const v of list)m[v]=1;return m;}
const EVENT_SET=set(EVENT_NAMES);
const TOOL_SET=set(TOOLS);
const DECK_SET=set(DECK_IDS);
const SPREAD_SET=set(SPREAD_IDS);
const LANG_SET=set(LANGS);
const REASON_SET=set(BLOCK_REASONS);
function inSet(s,v){return typeof v==='string'&&s[v]===1;}
function isEventName(name){return inSet(EVENT_SET,name);}
const PRIMARY_CARD_SET=(()=>{
const m=Object.create(null);
for(let n=0;n<=21;n++)m['major-'+String(n).padStart(2,'0')]=1;
return m;
})();
function sanitise(name,params){
const p=params||{};
const out={};
if(inSet(TOOL_SET,p.tool))out.tool=p.tool;
if(inSet(SPREAD_SET,p.spread))out.spread=p.spread;
if(inSet(DECK_SET,p.deck))out.deck=p.deck;
if(inSet(LANG_SET,p.lang))out.lang=p.lang;
if(Number.isInteger(p.reversed_count)&&p.reversed_count>=0&&p.reversed_count<=78){
out.reversed_count=p.reversed_count;
}
if(name==='ai_note_blocked'&&inSet(REASON_SET,p.reason))out.reason=p.reason;
if(name==='email_submit'&&inSet(PRIMARY_CARD_SET,p.primary_card))out.primary_card=p.primary_card;
return out;
}
function emit(root,name,params){
if(!isEventName(name))return null;
const detail=sanitise(name,params);
try{
const g=globalThis.gtag;
if(typeof g==='function')g('event',name,detail);
}catch{}
try{
const s=globalThis.Shopify;
if(s&&s.analytics&&typeof s.analytics.publish==='function')s.analytics.publish(name,detail);
}catch{}
try{
if(root&&typeof root.dispatchEvent==='function'){
const C=globalThis.CustomEvent;
if(typeof C==='function'){
root.dispatchEvent(new C(name,{detail,bubbles:true,composed:true}));
}
}
}catch{}
return detail;
}
function inView(node,fn){
const IO=globalThis.IntersectionObserver;
if(typeof IO!=='function'||!node){fn();return()=>{};}
let done=false;
const obs=new IO((entries)=>{
for(const e of entries){
if(e.isIntersecting&&!done){done=true;obs.disconnect();fn();}
}
},{threshold:0.4});
obs.observe(node);
return()=>obs.disconnect();
}

return { "EVENT_NAMES": EVENT_NAMES, "TOOLS": TOOLS, "BLOCK_REASONS": BLOCK_REASONS, "isEventName": isEventName, "sanitise": sanitise, "emit": emit, "inView": inView };
})();

__m["cart"] = (function () {
const{isDeckId}=__m["draw"];
const{localPath}=__m["compose"];
const{TOOLS}=__m["events"];
const{el}=__m["dom"];
const TOOL_SET=(()=>{const m=Object.create(null);for(const t of TOOLS)m[t]=1;return m;})();
function cartPayload(tool,deck,variantId){
if(typeof tool!=='string'||TOOL_SET[tool]!==1)return null;
if(!isDeckId(deck))return null;
if(!Number.isInteger(variantId)||variantId<=0)return null;
return{
items:[{id:variantId,quantity:1}],
attributes:{_df_tool:tool,_df_deck:deck},
};
}
function deckOf(data,deckId){
if(!data||!Array.isArray(data.decks)||!isDeckId(deckId))return null;
for(const d of data.decks)if(d&&d.deck_id===deckId)return d;
return null;
}
function inStock(deck){
return!!(deck&&deck.available!==false&&deck.in_stock!==false
&&deck.product&&deck.product.available!==false);
}
function nextInStock(data,afterDeckId){
const list=(data&&Array.isArray(data.decks))?data.decks.filter((d)=>d&&d.available!==false):[];
if(list.length===0)return null;
const start=Math.max(0,list.findIndex((d)=>d.deck_id===afterDeckId));
for(let k=1;k<=list.length;k++){
const d=list[(start+k)%list.length];
if(d.deck_id!==afterDeckId&&inStock(d))return d;
}
return null;
}
async function addToCart(data,opts){
const o=opts||{};
const route=localPath(data&&data.routes&&data.routes.cart_add);
if(!route)return{ok:false,status:0,error:'route',payload:null};
const d=deckOf(data,o.deck);
const variantId=d&&d.product?d.product.variant_id:null;
const payload=cartPayload(o.tool,o.deck,variantId);
if(!payload)return{ok:false,status:0,error:'payload',payload:null};
if(!inStock(d))return{ok:false,status:0,error:'out_of_stock',payload};
const f=o.fetchImpl||globalThis.fetch;
if(typeof f!=='function')return{ok:false,status:0,error:'no_fetch',payload};
try{
const res=await f(route,{
method:'POST',
headers:{'Content-Type':'application/json',Accept:'application/json'},
body:JSON.stringify(payload),
});
return{ok:!!res.ok,status:res.status||0,error:res.ok?null:'http',payload};
}catch{
return{ok:false,status:0,error:'network',payload};
}
}
function offerableDecks(data){
const list=(data&&Array.isArray(data.decks))?data.decks:[];
return list.filter((d)=>d&&typeof d.deck_id==='string'
&&isDeckId(d.deck_id)
&&d.available!==false);
}
function defaultDeck(data){
const offerable=offerableDecks(data);
const ok=(id)=>(typeof id==='string'&&offerable.some((d)=>d.deck_id===id))?id:null;
const offer=(data&&data.offer)||{};
return ok(offer.default_deck)||ok(offer.best_seller)||(offerable[0]?offerable[0].deck_id:null);
}
async function offerAdd(host,o){
const opts=o||{};
const deck=opts.deck;
const btn=opts.button||null;
const status=opts.status||null;
if(btn)btn.setAttribute('disabled','disabled');
const res=await addToCart(host.data,{tool:opts.tool,deck:deck.deck_id});
if(btn)btn.removeAttribute('disabled');
if(res.ok){
host.track('add_to_cart',{tool:opts.tool,deck:deck.deck_id});
const done=host.s('added_to_cart');
if(status&&done)status.textContent=done;
const cartUrl=localPath(host.data.routes&&host.data.routes.cart);
const cartLabel=host.s('go_to_cart');
if(status&&cartUrl&&cartLabel){
status.appendChild(el('a',{cls:'df-rr-offer__cart',attrs:{href:cartUrl},text:cartLabel}));
}
}else{
const failed=host.s('add_failed');
if(status&&failed)status.textContent=failed;
}
host.fire('df-cart',{ok:res.ok,error:res.error,deck:deck.deck_id,code:opts.code||null});
return res;
}

return { "cartPayload": cartPayload, "deckOf": deckOf, "inStock": inStock, "nextInStock": nextInStock, "addToCart": addToCart, "offerableDecks": offerableDecks, "defaultDeck": defaultDeck, "offerAdd": offerAdd };
})();

__m["birth-heights"] = (function () {
const BREAKPOINTS=[360,390,412,430,768,1280];
const BIRTH_HEIGHTS={
'3':[4085,3859,3747,3633,2946,2781],
'4':[3801,3685,3488,3460,2773,2580],
'5':[3907,3792,3707,3619,2907,2741],
'6':[4065,3922,3837,3642,2980,2787],
'7':[3832,3747,3605,3548,2860,2667],
'8':[3857,3628,3487,3459,2802,2581],
'9':[3888,3745,3604,3522,2860,2667],
'10-1':[4280,4195,4046,3947,3363,3104],
'11-2':[4141,4026,3961,3865,3195,3019],
'12-3':[4077,3906,3758,3717,3134,2958],
'13-4':[4111,3908,3847,3777,3137,2961],
'14-5':[4134,3969,3876,3835,3165,3017],
'15-6':[4106,3992,3928,3860,3182,2989],
'16-7':[4125,4013,3921,3850,3181,3033],
'17-8':[4009,3896,3776,3705,3094,2891],
'18-9':[4127,3983,3921,3937,3181,3033],
'19-10-1':[5243,5046,4924,4883,3665,3459],
'20-2':[4104,3878,3814,3746,3078,2902],
'21-3':[3963,3877,3757,3745,3105,2929],
};
function reserveFor(key,width){
const row=Object.prototype.hasOwnProperty.call(BIRTH_HEIGHTS,key)?BIRTH_HEIGHTS[key]:null;
if(!row)return null;
const w=Number(width);
if(!Number.isFinite(w))return row[1];
let i=0;
while(i<BREAKPOINTS.length-1&&w>=BREAKPOINTS[i+1])i++;
return row[i]||null;
}

return { "BREAKPOINTS": BREAKPOINTS, "BIRTH_HEIGHTS": BIRTH_HEIGHTS, "reserveFor": reserveFor };
})();

__m["bundle"] = (function () {
const{own}=__m["text"];
const STATE=new WeakMap();
const IDLE_MS=2000;
const WARNED=new WeakSet();
function warnOnce(data,reason){
if(!data||WARNED.has(data))return;
WARNED.add(data);
if(globalThis.console&&globalThis.console.warn){
globalThis.console.warn('[df-rr] tier B not loaded: '+reason);
}
}
function bundleUrl(data){
const v=data&&data.cards_url;
if(typeof v!=='string')return null;
const s=v.trim();
if(s==='')return null;
if(s.charCodeAt(0)!==47){
warnOnce(data,'cards_url is not root-relative: '+JSON.stringify(s.slice(0,120)));
return null;
}
if(s.charCodeAt(1)===47){
warnOnce(data,'cards_url is protocol-relative ("//…"), not root-relative: '+JSON.stringify(s.slice(0,120)));
return null;
}
if(/[\s"'<>\\]/.test(s)){
warnOnce(data,'cards_url contains a disallowed character: '+JSON.stringify(s.slice(0,120)));
return null;
}
return s;
}
function deferred(data){
if(!bundleUrl(data))return false;
const s=STATE.get(data);
return!s||!s.done;
}
function mergeBundle(data,json){
if(!data||!json||typeof json!=='object'||Array.isArray(json))return 0;
const cards=(json.cards&&typeof json.cards==='object'&&!Array.isArray(json.cards))?json.cards:json;
if(!data.cards||typeof data.cards!=='object')data.cards=Object.create(null);
let n=0;
for(const id of Object.keys(cards)){
if(id==='__proto__'||id==='constructor'||id==='prototype')continue;
const extra=own(cards,id);
if(!extra||typeof extra!=='object'||Array.isArray(extra))continue;
const target=own(data.cards,id);
if(target&&typeof target==='object'){
for(const k of Object.keys(extra)){
if(k==='__proto__'||k==='constructor'||k==='prototype')continue;
target[k]=extra[k];
}
}else{
data.cards[id]=extra;
}
n++;
}
return n;
}
function loadBundle(data,opts){
const url=bundleUrl(data);
if(!url)return Promise.resolve(false);
const existing=STATE.get(data);
if(existing)return existing.promise;
const f=(opts&&opts.fetchImpl)||globalThis.fetch;
if(typeof f!=='function'){
warnOnce(data,'no fetch implementation available');
const done={done:true,ok:false,promise:Promise.resolve(false)};
STATE.set(data,done);
return done.promise;
}
const state={done:false,ok:false,promise:null};
STATE.set(data,state);
state.promise=Promise.resolve(f(url,{credentials:'omit'}))
.then((r)=>{
if(r&&r.ok)return r.json();
warnOnce(data,'response was not ok'+(r&&r.status!==undefined?' (status '+r.status+')':''));
return null;
})
.then((json)=>{
const n=mergeBundle(data,json);
state.ok=n>0;
if(!state.ok&&json!==null)warnOnce(data,'response carried no usable card fields');
})
.catch((e)=>{
state.ok=false;
warnOnce(data,'fetch or parse failed: '+(e&&e.message?e.message:String(e)));
})
.then(()=>{state.done=true;return state.ok;});
return state.promise;
}
function idlePrefetch(data,opts){
if(!bundleUrl(data))return()=>{};
const t=globalThis.setTimeout;
if(typeof t!=='function')return()=>{};
const id=t(()=>{loadBundle(data,opts);},IDLE_MS);
return()=>{try{globalThis.clearTimeout(id);}catch{}};
}
function _reset(data){STATE.delete(data);WARNED.delete(data);}

return { "IDLE_MS": IDLE_MS, "bundleUrl": bundleUrl, "deferred": deferred, "mergeBundle": mergeBundle, "loadBundle": loadBundle, "idlePrefetch": idlePrefetch, "_reset": _reset };
})();

__m["deck-images"] = (function () {
const{own}=__m["text"];
const STATE=new WeakMap();
const WARNED=new WeakSet();
function hasImages(deck){
return!!(deck&&deck.cards&&typeof deck.cards==='object'&&Object.keys(deck.cards).length>0);
}
function warnOnce(data,reason){
if(!data||WARNED.has(data))return;
WARNED.add(data);
if(globalThis.console&&globalThis.console.warn){
globalThis.console.warn('[df-rr] deck images not loaded: '+reason);
}
}
function deckImagesUrl(data){
const v=data&&data.deck_images_url;
if(typeof v!=='string')return null;
const s=v.trim();
if(s==='')return null;
if(s.charCodeAt(0)!==47){
warnOnce(data,'deck_images_url is not root-relative: '+JSON.stringify(s.slice(0,120)));
return null;
}
if(s.charCodeAt(1)===47){
warnOnce(data,'deck_images_url is protocol-relative ("//…"), not root-relative: '+JSON.stringify(s.slice(0,120)));
return null;
}
if(/[\s"'<>\\]/.test(s)){
warnOnce(data,'deck_images_url contains a disallowed character: '+JSON.stringify(s.slice(0,120)));
return null;
}
return s;
}
function deckImagesDeferred(data,deckId){
const decks=(data&&Array.isArray(data.decks))?data.decks:[];
const deck=decks.find((d)=>d&&d.deck_id===deckId);
if(!deck||hasImages(deck))return false;
if(!deckImagesUrl(data))return false;
const s=STATE.get(data);
return!s||!s.done;
}
function mergeDeckImages(data,json){
if(!data||!json||typeof json!=='object'||Array.isArray(json))return 0;
const decks=(json.decks&&typeof json.decks==='object'&&!Array.isArray(json.decks))?json.decks:json;
if(!Array.isArray(data.decks))return 0;
let n=0;
for(const deck of data.decks){
if(!deck||hasImages(deck))continue;
const extra=own(decks,deck.deck_id);
if(!extra||typeof extra!=='object'||Array.isArray(extra))continue;
if(extra.back)deck.back=extra.back;
if(extra.cards)deck.cards=extra.cards;
if(extra.cover&&!deck.cover)deck.cover=extra.cover;
if(extra.card_size&&!deck.card_size)deck.card_size=extra.card_size;
n++;
}
return n;
}
function loadDeckImages(data,opts){
const url=deckImagesUrl(data);
if(!url)return Promise.resolve(false);
const existing=STATE.get(data);
if(existing)return existing.promise;
const f=(opts&&opts.fetchImpl)||globalThis.fetch;
if(typeof f!=='function'){
warnOnce(data,'no fetch implementation available');
const done={done:true,ok:false,promise:Promise.resolve(false)};
STATE.set(data,done);
return done.promise;
}
const state={done:false,ok:false,promise:null};
STATE.set(data,state);
state.promise=Promise.resolve(f(url,{credentials:'omit'}))
.then((r)=>{
if(r&&r.ok)return r.json();
warnOnce(data,'response was not ok'+(r&&r.status!==undefined?' (status '+r.status+')':''));
return null;
})
.then((json)=>{
const n=mergeDeckImages(data,json);
state.ok=n>0;
if(!state.ok&&json!==null)warnOnce(data,'response carried no usable deck fields');
})
.catch((e)=>{
state.ok=false;
warnOnce(data,'fetch or parse failed: '+(e&&e.message?e.message:String(e)));
})
.then(()=>{state.done=true;return state.ok;});
return state.promise;
}
function _reset(data){STATE.delete(data);WARNED.delete(data);}

return { "deckImagesUrl": deckImagesUrl, "deckImagesDeferred": deckImagesDeferred, "mergeDeckImages": mergeDeckImages, "loadDeckImages": loadDeckImages, "_reset": _reset };
})();

__m["daily-heights"] = (function () {
const BREAKPOINTS=[360,390,412,430,768,1280];
const DAILY_HEIGHTS={
'major-00':[1979,1930,1907,1855,1986,1986],
'major-01':[1929,1905,1882,1830,1986,1986],
'major-02':[1929,1905,1882,1830,1986,1986],
'major-03':[1954,1930,1882,1830,1961,1961],
'major-04':[1929,1880,1858,1805,1961,1961],
'major-05':[1954,1905,1882,1830,1961,1961],
'major-06':[1954,1930,1907,1830,1986,1986],
'major-07':[1954,1905,1858,1805,1961,1961],
'major-08':[1954,1880,1858,1805,1961,1961],
'major-09':[1954,1905,1882,1830,1986,1986],
'major-10':[1929,1905,1882,1805,1961,1961],
'major-11':[1979,1930,1907,1830,1986,1986],
'major-12':[1979,1954,1907,1855,2011,2011],
'major-13':[1979,1930,1882,1805,1936,1936],
'major-14':[1929,1905,1882,1830,1986,1986],
'major-15':[1954,1905,1882,1830,1986,1986],
'major-16':[1954,1930,1882,1830,1986,1986],
'major-17':[1929,1905,1882,1830,1986,1986],
'major-18':[1905,1880,1858,1805,1961,1961],
'major-19':[2004,1905,1882,1830,1986,1986],
'major-20':[1954,1905,1882,1830,1961,1961],
'major-21':[1929,1905,1882,1830,1986,1986],
'wands-01':[1954,1905,1858,1805,1961,1961],
'wands-02':[1954,1905,1882,1830,1986,1986],
'wands-03':[1929,1905,1882,1830,1961,1961],
'wands-04':[1929,1905,1858,1805,1961,1961],
'wands-05':[1954,1905,1882,1830,1986,1986],
'wands-06':[1954,1930,1907,1780,1936,1936],
'wands-07':[1929,1905,1858,1805,1936,1936],
'wands-08':[1905,1880,1858,1805,1961,1961],
'wands-09':[1954,1905,1858,1780,1936,1936],
'wands-10':[1954,1905,1882,1805,1961,1961],
'wands-11':[1954,1905,1882,1805,1936,1936],
'wands-12':[1954,1905,1882,1830,1961,1961],
'wands-13':[2004,1979,1932,1880,2035,2035],
'wands-14':[1954,1905,1882,1830,1986,1986],
'cups-01':[1929,1880,1858,1780,1936,1936],
'cups-02':[1979,1905,1882,1830,1986,1986],
'cups-03':[1954,1905,1882,1830,1986,1986],
'cups-04':[1954,1905,1882,1830,1961,1961],
'cups-05':[1929,1905,1882,1830,1936,1936],
'cups-06':[1954,1905,1882,1830,1986,1986],
'cups-07':[1954,1905,1882,1805,1912,1912],
'cups-08':[1954,1880,1858,1805,1961,1961],
'cups-09':[1929,1905,1858,1805,1961,1961],
'cups-10':[1954,1855,1833,1756,1912,1912],
'cups-11':[1954,1930,1907,1855,1986,1986],
'cups-12':[1979,1954,1907,1830,1986,1986],
'cups-13':[1954,1905,1882,1830,1986,1986],
'cups-14':[2004,1979,1957,1830,1986,1986],
'swords-01':[1929,1880,1833,1756,1912,1912],
'swords-02':[1954,1905,1882,1830,1986,1986],
'swords-03':[1929,1880,1833,1780,1936,1936],
'swords-04':[1905,1855,1833,1780,1936,1936],
'swords-05':[1954,1880,1833,1780,1912,1912],
'swords-06':[1954,1905,1882,1830,1986,1986],
'swords-07':[1954,1930,1858,1805,1936,1936],
'swords-08':[1929,1905,1882,1830,1961,1961],
'swords-09':[1929,1880,1858,1756,1912,1912],
'swords-10':[1954,1930,1907,1830,1986,1986],
'swords-11':[1979,1954,1932,1855,1986,1986],
'swords-12':[1954,1905,1882,1830,1986,1986],
'swords-13':[1929,1905,1882,1830,1986,1986],
'swords-14':[2004,1930,1907,1855,1986,1986],
'pentacles-01':[1929,1880,1858,1805,1961,1961],
'pentacles-02':[1954,1905,1882,1830,1986,1986],
'pentacles-03':[1979,1930,1907,1830,1961,1961],
'pentacles-04':[1954,1905,1882,1830,1961,1961],
'pentacles-05':[1954,1905,1882,1780,1936,1936],
'pentacles-06':[1929,1905,1882,1830,1986,1986],
'pentacles-07':[1954,1905,1858,1805,1961,1961],
'pentacles-08':[1929,1880,1858,1805,1961,1961],
'pentacles-09':[1929,1905,1858,1805,1936,1936],
'pentacles-10':[1929,1905,1882,1830,1986,1986],
'pentacles-11':[1979,1954,1907,1855,2011,2011],
'pentacles-12':[1979,1930,1907,1855,2011,2011],
'pentacles-13':[1954,1930,1907,1855,1986,1986],
'pentacles-14':[1979,1954,1932,1855,2011,2011],
};
function heightFor(cardId,width){
const row=DAILY_HEIGHTS[cardId];
if(!row)return null;
const w=typeof width==='number'&&width>0?width:BREAKPOINTS[BREAKPOINTS.length-1];
let i=BREAKPOINTS.length-1;
for(let k=0;k<BREAKPOINTS.length;k++){
if(w<=BREAKPOINTS[k]){i=k;break;}
}
return row[i];
}

return { "BREAKPOINTS": BREAKPOINTS, "DAILY_HEIGHTS": DAILY_HEIGHTS, "heightFor": heightFor };
})();

__m["base"] = (function () {
const{el,clear,line}=__m["dom"];
const{emit}=__m["events"];
const{LANGS}=__m["compose"];
const{TOPICS,isTopic}=__m["lean"];
const{fill}=__m["text"];
const LANG_SET=(()=>{const m=Object.create(null);for(const l of LANGS)m[l]=1;return m;})();
const MARK='data-rr-';
function attrNames(node){
if(!node||typeof node.getAttributeNames!=='function')return[];
return node.getAttributeNames();
}
function marked(node){
for(const n of attrNames(node))if(String(n).indexOf(MARK)===0)return true;
return false;
}
function carriesControl(node){
if(marked(node))return true;
for(const c of(node&&node.childNodes)||[])if(carriesControl(c))return true;
return false;
}
function findBy(node,pred){
if(!node)return null;
if(typeof node.hasAttribute==='function'&&pred(node))return node;
for(const c of node.childNodes||[]){
const hit=findBy(c,pred);
if(hit)return hit;
}
return null;
}
function findMarked(node,attr){
return findBy(node,(n)=>n.hasAttribute(attr));
}
function normaliseAdopted(node){
if(node.tagName==='INPUT'||node.tagName==='SELECT'||node.tagName==='TEXTAREA'){
node.removeAttribute('name');
node.setAttribute('autocomplete','off');
node.setAttribute('data-clarity-mask','true');
}
for(const c of node.childNodes||[])normaliseAdopted(c);
}
function findById(node,id){
return findBy(node,(n)=>n.getAttribute&&n.getAttribute('id')===id);
}
function makeBase(){
const H=globalThis.HTMLElement;
if(typeof H!=='function')throw new Error('df-rr: custom elements need a document');
return class DFBase extends H{
constructor(){
super();
this._mounted=false;
this._data=null;
this._opts=null;
this._root=null;
this._fallback=null;
this._adopted=[];
this._unwire=[];
}
get data(){return this._data;}
get mounted(){return this._mounted;}
get alive(){
if(!this._mounted)return false;
try{return!!globalThis.document;}catch{return false;}
}
mountWith(data,opts){
if(this._mounted)return this;
this._data=data;
this._opts=opts||{};
const fallbackLang=data.strings&&data.strings.strings_fallback_lang;
const effectiveLang=(typeof fallbackLang==='string'&&LANG_SET[fallbackLang]===1)?fallbackLang:data.lang;
if(typeof effectiveLang==='string'&&LANG_SET[effectiveLang]===1)this.setAttribute('lang',effectiveLang);
const keep=el('div',{cls:'df-rr-fallback',attrs:{hidden:'hidden'}});
const kids=[];
while(this.firstChild)kids.push(this.removeChild(this.firstChild));
this._adopted=[];
for(const kid of kids){
if(carriesControl(kid)){normaliseAdopted(kid);this._adopted.push(kid);this.appendChild(kid);}
else keep.appendChild(kid);
}
this._fallback=keep;
this.appendChild(keep);
this._root=el('div',{cls:'df-rr'});
this.appendChild(this._root);
try{
this.render(this._root);
if(!this.contentComesLater()&&this._visibleText()===''){
throw new Error('df-rr: <'+String(this.tagName||'').toLowerCase()
+'> rendered no text and has nothing to show — the page data has no strings for it, '
+'or none of its fields are filled. The server-rendered fallback is kept.');
}
}catch(e){
this.destroy();
throw e;
}
this._mounted=true;
this.fire('df-ready');
return this;
}
destroy(){
for(const off of this._unwire||[]){try{off();}catch{}}
this._unwire=[];
const adopted=this._adopted||[];
clear(this);
for(const a of adopted)this.appendChild(a);
if(this._fallback){
while(this._fallback.firstChild)this.appendChild(this._fallback.firstChild);
}
this._adopted=[];
this._fallback=null;
this._root=null;
this._mounted=false;
}
adopted(marker){
const attr=MARK+String(marker);
for(const root of this._adopted||[]){
const hit=findMarked(root,attr);
if(hit)return hit;
}
return null;
}
adoptedById(id){
for(const root of this._adopted||[]){
const hit=findById(root,id);
if(hit)return hit;
}
return null;
}
questionBox(parent,placeholderKey){
if(this._opts&&this._opts.questionEl){
const q=this._opts.questionEl;
if(q&&typeof q.setAttribute==='function')q.setAttribute('data-clarity-mask','true');
return q;
}
const server=this.adopted('question')||this.adoptedById('rr-question');
if(server)return server;
const box=el('textarea',{
cls:'df-rr-question',
attrs:{
rows:'2',
placeholder:this.s(placeholderKey)||'',
maxlength:'200',
autocomplete:'off',
'data-clarity-mask':'true',
},
});
parent.appendChild(box);
return box;
}
wire(node,type,fn){
if(!node||typeof node.addEventListener!=='function')return null;
node.addEventListener(type,fn);
(this._unwire=this._unwire||[]).push(()=>node.removeEventListener(type,fn));
return node;
}
_visibleText(){
let out=String((this._root&&this._root.textContent)||'');
for(const a of this._adopted||[])out+=String(a.textContent||'');
return out.trim();
}
render(){}
contentComesLater(){return false;}
fire(name,detail){
try{
const C=globalThis.CustomEvent;
if(typeof C==='function')this.dispatchEvent(new C(name,{detail:detail||null,bubbles:true}));
}catch{}
}
track(name,params){
const p=Object.assign({},params||{});
if(this._data)p.lang=this._data.lang;
return emit(this,name,p);
}
pick(attr,allowed,fallback){
const v=this.getAttribute(attr);
if(typeof v==='string'&&allowed.indexOf(v)!==-1)return v;
return fallback;
}
tool(allowed,fallback){
return this.pick('tool',allowed,(this._data&&this._data.tool)||fallback);
}
s(path){
let cur=this._data&&this._data.strings;
for(const part of String(path).split('.')){
if(!cur||!Object.prototype.hasOwnProperty.call(cur,part))return null;
cur=cur[part];
}
if(typeof cur!=='string'||cur.trim()==='')return null;
return /\[\[[^\]]*\]\]/.test(cur)?null:cur;
}
questionHelp(parent,helpKey,box){
const p=line('p',this.s(helpKey),'df-rr-question__help');
if(!p)return null;
if(parent)parent.appendChild(p);
if(box&&typeof box.setAttribute==='function'){
const id='df-rr-question-help';
p.setAttribute('id',id);
box.setAttribute('aria-describedby',id);
const name=box.getAttribute&&box.getAttribute('placeholder');
if(name&&!(box.getAttribute('aria-label')||box.getAttribute('aria-labelledby'))){
box.setAttribute('aria-label',name);
}
}
return p;
}
topicChips(parent,current,onPick){
const prompt=this.s('question_topic_prompt')||this.s('daily_focus_prompt');
if(!prompt)return null;
const wrap=el('div',{cls:'df-rr-topic'});
wrap.appendChild(el('p',{cls:'df-rr-label',attrs:{id:'df-rr-topiclabel'},text:prompt}));
const group=el('div',{cls:'df-rr-picker',attrs:{role:'radiogroup','aria-labelledby':'df-rr-topiclabel'}});
for(const topic of TOPICS){
const label=this.s('daily_focus_'+topic);
if(!label)continue;
const on=current===topic;
const b=el('button',{
cls:'df-rr-chip'+(on?' is-on':''),
attrs:{type:'button',role:'radio','aria-checked':on?'true':'false','data-topic':topic},
text:label,
});
b.addEventListener('click',()=>{if(typeof onPick==='function')onPick(topic);});
group.appendChild(b);
}
if(!group.childNodes.length)return null;
wrap.appendChild(group);
if(parent)parent.appendChild(wrap);
return wrap;
}
readForLine(topic){
if(!isTopic(topic))return null;
const label=this.s('daily_focus_'+topic);
return line('p',fill(this.s('read_for'),{topic:label}),'df-rr-readfor df-rr-label');
}
};
}
return { "makeBase": makeBase };
})();

__m["card-node"] = (function () {
const{cardName}=__m["cards"];
function cardNode(data,spec){
const s=spec||{};
if(!cardName(data,s.cardId))return null;
const node=globalThis.document.createElement('df-card');
node.setAttribute('card-id',s.cardId);
if(s.deck)node.setAttribute('deck',s.deck);
if(s.reversed)node.setAttribute('reversed','true');
if(s.size)node.setAttribute('size',String(s.size));
if(s.style)node.setAttribute('style',s.style);
return node;
}

return { "cardNode": cardNode };
})();

__m["card-el"] = (function () {
const{el,clear}=__m["dom"];
const{isCardId,cardName}=__m["cards"];
const{own,str}=__m["text"];
const{DECK_IDS}=__m["draw"];
const{deckImagesDeferred,loadDeckImages}=__m["deck-images"];
const SIZES=['450','225'];
function imageFor(data,deckId,cardId,size){
if(!isCardId(cardId))return null;
const decks=(data&&Array.isArray(data.decks))?data.decks:[];
for(const d of decks){
if(d&&d.deck_id===deckId){
const pair=own(d.cards,cardId);
const url=pair?own(pair,size):null;
return str(url);
}
}
return null;
}
const CARD_RATIO=1.75;
function cardBox(data,deckId,size){
const width=Number(size);
const fallback={width:String(size),height:String(Math.round(width*CARD_RATIO))};
const decks=(data&&Array.isArray(data.decks))?data.decks:[];
for(const d of decks){
if(!d||d.deck_id!==deckId)continue;
const table=own(d,'card_size');
const pair=table?own(table,String(size)):null;
if(Array.isArray(pair)&&pair.length===2
&&Number.isFinite(Number(pair[0]))&&Number.isFinite(Number(pair[1]))
&&Number(pair[0])>0&&Number(pair[1])>0){
return{width:String(Math.round(Number(pair[0]))),height:String(Math.round(Number(pair[1])))};
}
return fallback;
}
return fallback;
}
function makeCardEl(Base){
return class DFCard extends Base{
static get observedAttributes(){return['card-id','deck','reversed','size'];}
attributeChangedCallback(){if(this.alive)this.render(this._root);}
render(root){
clear(root);
const data=this.data;
const cardId=this.getAttribute('card-id');
if(!isCardId(cardId))return;
const card=own(data.cards,cardId)||{};
const name=cardName(data,cardId);
if(!name)return;
const reversed=this.getAttribute('reversed')!==null&&this.getAttribute('reversed')!=='false';
const size=this.pick('size',SIZES,'450');
const deck=this.pick('deck',DECK_IDS,(this._opts&&this._opts.deck)||null);
if(deck&&deckImagesDeferred(data,deck)){
loadDeckImages(data,this._opts).then(()=>{
if(this.alive)this.render(this._root);
});
}
const url=imageFor(data,deck,cardId,size);
const revLabel=this.s('reversed_label');
const label=reversed&&revLabel?`${name} — ${revLabel}`:name;
const fig=el('figure',{
cls:'df-rr-card'+(reversed?' df-rr-card--rev':''),
attrs:{'data-card-id':cardId,'data-reversed':reversed?'true':'false'},
});
const box=cardBox(data,deck,size);
if(url){
fig.appendChild(el('img',{
cls:'df-rr-card__img',
attrs:{
src:url,alt:label,width:box.width,height:box.height,
loading:'lazy',decoding:'async',
},
}));
}else if(deck&&deckImagesDeferred(data,deck)){
fig.appendChild(el('div',{
cls:'df-rr-card__slot',
attrs:{
'aria-hidden':'true',
style:'aspect-ratio:'+box.width+'/'+box.height,
},
}));
}
const cap=el('figcaption',{cls:'df-rr-card__name'},[el('span',{text:name})]);
if(reversed&&revLabel)cap.appendChild(el('span',{cls:'df-rr-card__rev',text:revLabel}));
fig.appendChild(cap);
root.appendChild(fig);
}
};
}

return { "SIZES": SIZES, "imageFor": imageFor, "CARD_RATIO": CARD_RATIO, "cardBox": cardBox, "makeCardEl": makeCardEl };
})();

__m["reveal-el"] = (function () {
const{el,clear,prefersReducedMotion,focusTo,liveRegion,say}=__m["dom"];
const DEFAULT_STAGGER=120;
const FLIP_MS=600;
const LIVE_CLEAR_MS=FLIP_MS;
function makeRevealEl(Base){
return class DFReveal extends Base{
constructor(){
super();
this._live=null;
this._timers=[];
}
contentComesLater(){return true;}
render(root){
clear(root);
this._live=liveRegion();
this._slot=el('div',{cls:'df-rr-reveal'});
root.appendChild(this._slot);
root.appendChild(this._live);
}
setCards(nodes){
clear(this._slot);
for(const n of nodes){
const wrap=el('div',{cls:'df-rr-reveal__slot'});
wrap.appendChild(n);
this._slot.appendChild(wrap);
}
}
stagger(){
const raw=Number(this.getAttribute('stagger'));
if(!Number.isFinite(raw)||raw<0||raw>2000)return DEFAULT_STAGGER;
return raw;
}
reveal(names,onDone){
const reduced=prefersReducedMotion();
const step=reduced?0:this.stagger();
const slots=[];
for(let i=0;i<this._slot.children.length;i++)slots.push(this._slot.children[i]);
this._clearTimers();
say(this._live,'');
this._slot.setAttribute('data-motion',reduced?'fade':'flip');
slots.forEach((slot,i)=>{
const run=()=>{
slot.setAttribute('data-revealed','true');
const n=names&&names[i];
if(n)say(this._live,n);
if(i===slots.length-1){
this._timers.push(setTimeout(()=>say(this._live,''),LIVE_CLEAR_MS));
focusTo(this);
if(typeof onDone==='function')onDone(this);
}
};
if(step===0)run();
else this._timers.push(setTimeout(run,i*step));
});
if(step===0&&slots.length===0&&typeof onDone==='function')onDone(this);
}
_clearTimers(){
for(const t of this._timers)clearTimeout(t);
this._timers=[];
}
destroy(){
this._clearTimers();
super.destroy();
}
};
}

return { "DEFAULT_STAGGER": DEFAULT_STAGGER, "FLIP_MS": FLIP_MS, "LIVE_CLEAR_MS": LIVE_CLEAR_MS, "makeRevealEl": makeRevealEl };
})();

__m["read-it-yourself-el"] = (function () {
const{el,clear,line}=__m["dom"];
function makeReadItYourselfEl(Base){
return class DFReadItYourself extends Base{
constructor(){super();this._opened=false;this._reading=null;}
setReading(reading){
this._reading=reading;
if(this.alive)this.render(this._root);
}
contentComesLater(){return true;}
render(root){
clear(root);
const r=this._reading;
const y=r&&r.yourself;
if(!y)return;
const summary=this.s('yourself_summary')||y.prompt;
if(!summary)return;
const det=el('details',{cls:'df-rr-yourself'});
det.appendChild(el('summary',{cls:'df-rr-yourself__summary',text:summary}));
const body=el('div',{cls:'df-rr-yourself__body'});
const p=line('p',y.prompt,'df-rr-yourself__prompt');
if(p)body.appendChild(p);
const a=line('p',y.ask_q,'df-rr-yourself__ask');
if(a)body.appendChild(a);
if(Array.isArray(y.positions)&&y.positions.length){
const pl=el('ul',{cls:'df-rr-yourself__positions'});
for(const p of y.positions){
const li=el('li',{cls:'df-rr-yourself__position',attrs:{'data-key':p.key}});
const heading=line('strong',p.name,'df-rr-yourself__position-name');
if(heading)li.appendChild(heading);
const asks=line('p',p.asks,'df-rr-yourself__position-asks');
if(asks)li.appendChild(asks);
const lens=line('p',p.lens,'df-rr-yourself__position-lens');
if(lens)li.appendChild(lens);
if(li.childNodes.length)pl.appendChild(li);
}
if(pl.childNodes.length)body.appendChild(pl);
}
if(Array.isArray(y.look_q)&&y.look_q.length){
const ql=el('ul',{cls:'df-rr-yourself__looks'});
for(const q of y.look_q){
if(typeof q!=='string'||q.trim()==='')continue;
ql.appendChild(el('li',{text:q}));
}
if(ql.childNodes.length)body.appendChild(ql);
}
if(Array.isArray(y.notices)&&y.notices.length){
const ul=el('ul',{cls:'df-rr-notices'});
for(const n of y.notices){
if(!n||!n.text||!n.means)continue;
ul.appendChild(el('li',{cls:'df-rr-notice',attrs:{'data-kind':n.kind}},[
el('span',{cls:'df-rr-notice__what',text:n.text}),
el('span',{cls:'df-rr-notice__means',text:n.means}),
]));
}
if(ul.childNodes.length)body.appendChild(ul);
}
det.appendChild(body);
det.addEventListener('toggle',()=>{
if(!this._opened&&det.hasAttribute('open')){
this._opened=true;
this.track('self_answer_open',{tool:this.data.tool,spread:r.spread,deck:r.deck});
}
});
root.appendChild(det);
}
};
}

return { "makeReadItYourselfEl": makeReadItYourselfEl };
})();

__m["deck-offer-el"] = (function () {
const{el,clear,line}=__m["dom"];
const{inView}=__m["events"];
const{offerAdd,deckOf,inStock,nextInStock,defaultDeck,offerableDecks}=__m["cart"];
const{DECK_IDS}=__m["draw"];
const{TOOLS}=__m["events"];
const{localPath}=__m["compose"];
const{fill,str,displayNameOf}=__m["text"];
function makeDeckOfferEl(Base){
return class DFDeckOffer extends Base{
constructor(){super();this._stop=null;this._viewedDeck=null;}
static get observedAttributes(){return['deck','tool','code'];}
attributeChangedCallback(){if(this.alive)this.render(this._root);}
code(){
const v=this.getAttribute('code');
return(typeof v==='string'&& /^[A-Z0-9][A-Z0-9-]{0,63}$/.test(v))?v:null;
}
render(root){
clear(root);
const data=this.data;
const deckId=this.pick('deck',DECK_IDS,(this._opts&&this._opts.deck)||defaultDeck(data));
const tool=this.tool(TOOLS,'table');
const deck=deckOf(data,deckId);
if(!deck||!deck.product)return;
if(!offerableDecks(data).some((d)=>d.deck_id===deck.deck_id))return;
const offer=data.offer||{};
const box=el('section',{cls:'df-rr-offer',attrs:{'data-deck':deck.deck_id}});
const deckName=displayNameOf(deck)||deck.deck_id;
const price=str(deck.product.price);
const h=fill(this.s('offer_title'),{deck:deckName,price});
if(h)box.appendChild(el('h2',{cls:'df-rr-offer__title',text:h}));
const photo=str(deck.product.photo);
if(photo){
box.appendChild(el('img',{
cls:'df-rr-offer__photo',
attrs:{src:photo,alt:deckName,loading:'lazy',decoding:'async',width:'450',height:'450'},
}));
}
box.appendChild(el('p',{cls:'df-rr-offer__name',text:deckName}));
if(price)box.appendChild(el('p',{cls:'df-rr-offer__price',text:price}));
const variantLabel=str(offer.default_variant_label);
if(variantLabel)box.appendChild(el('p',{cls:'df-rr-offer__variant',text:variantLabel}));
const proof=line('p',str(offer.proof),'df-rr-offer__proof');
if(proof)box.appendChild(proof);
const keeps=line('p',str(offer.keeps_free),'df-rr-offer__keeps');
if(keeps)box.appendChild(keeps);
const status=el('p',{cls:'df-rr-offer__status',attrs:{'aria-live':'polite'}});
if(inStock(deck)){
const label=this.s('add_to_cart')||str(offer.default_variant_label)||deckName;
const btn=el('button',{
cls:'df-rr-btn df-rr-offer__add',
attrs:{type:'button'},
text:label,
});
btn.addEventListener('click',()=>{this._add(deck,tool,btn,status);});
box.appendChild(btn);
}else{
const back=this.s('back_soon');
if(back)box.appendChild(el('p',{cls:'df-rr-offer__backsoon',text:back}));
const alt=nextInStock(data,deck.deck_id);
if(alt&&alt.product){
const altUrl=localPath(alt.product.url);
const altLabel=this.s('try_this_deck');
if(altUrl&&altLabel){
box.appendChild(el('a',{
cls:'df-rr-btn df-rr-offer__alt',
attrs:{href:altUrl,'data-deck':alt.deck_id},
text:`${altLabel} ${displayNameOf(alt) || alt.deck_id}`,
}));
}
}
}
box.appendChild(status);
root.appendChild(box);
if(this._stop)this._stop();
if(this._viewedDeck===deck.deck_id){
this._stop=null;
}else{
this._stop=inView(box,()=>{
this._viewedDeck=deck.deck_id;
this.track('deck_offer_view',{tool,deck:deck.deck_id});
});
}
}
_add(deck,tool,btn,status){
return offerAdd(this,{deck,tool,button:btn,status,code:this.code()});
}
destroy(){
if(this._stop)this._stop();
this._stop=null;
super.destroy();
}
};
}

return { "makeDeckOfferEl": makeDeckOfferEl };
})();

__m["ai-note-el"] = (function () {
const{el,clear,linkedLine,focusTo}=__m["dom"];
const{TOOLS}=__m["events"];
const{str}=__m["text"];
const{safetyResponse,riskResponse}=__m["yesno"];
const MAX_QUESTION=200;
function noteRequest(reading,question,turnstile,code){
const q=typeof question==='string'?question.trim().slice(0,MAX_QUESTION):'';
if(q===''||!reading||!Array.isArray(reading.positions))return null;
const body={
q,
spread:reading.spread,
cards:reading.positions.map((p,i)=>({id:p.card_id,reversed:!!p.reversed,position:i})),
deck:reading.deck,
lang:reading.lang,
turnstile:typeof turnstile==='string'?turnstile:'',
};
if(typeof code==='string'&&code!=='')body.code=code;
return body;
}
function showStatusLinked(status,text,lang,links){
clear(status);
status.setAttribute('lang',lang);
const p=linkedLine('span',text,null,links);
if(p)status.appendChild(p);
}
function makeAiNoteEl(Base){
return class DFAiNote extends Base{
constructor(){super();this._reading=null;this._busy=false;}
setReading(reading){this._reading=reading;if(this.alive)this.render(this._root);}
contentComesLater(){return true;}
render(root){
clear(root);
const data=this.data;
if(!data.flags||data.flags.ai_notes!==true)return;
const ai=data.ai;
if(!ai||typeof ai.endpoint!=='string'||ai.endpoint.slice(0,8)!=='https://')return;
if(!this._reading)return;
const tool=this.tool(TOOLS,'table');
const box=el('section',{cls:'df-rr-ai'});
const consent=str(ai.consent_line);
if(consent)box.appendChild(el('p',{cls:'df-rr-ai__consent',text:consent}));
const btnLabel=this.s('ai_note_button');
const btn=el('button',{cls:'df-rr-btn df-rr-ai__ask',attrs:{type:'button'},text:btnLabel||'AI'});
const status=el('p',{cls:'df-rr-ai__status',attrs:{'aria-live':'polite'}});
const out=el('div',{cls:'df-rr-ai__note',attrs:{hidden:'hidden'}});
btn.addEventListener('click',()=>{this._ask(tool,btn,status,out);});
box.appendChild(btn);
box.appendChild(status);
box.appendChild(out);
root.appendChild(box);
this._turnstileMount=box;
}
question(){
const qEl=this._opts&&this._opts.questionEl;
const v=qEl&&typeof qEl.value==='string'?qEl.value:'';
return v.trim().slice(0,MAX_QUESTION);
}
async _ask(tool,btn,status,out){
if(this._busy)return;
const data=this.data;
const q=this.question();
const r=this._reading;
if(!q){status.removeAttribute('lang');status.textContent=this.s('ai_note_needs_question')||'';return;}
const safety=safetyResponse(q,data);
if(safety){
this.track('ai_note_blocked',{tool,deck:r.deck,spread:r.spread,reason:'safety'});
if(safety.text){
showStatusLinked(status,safety.text,safety.lang,safety.links);
}else{
status.removeAttribute('lang');
status.textContent='';
}
return;
}
const risk=riskResponse(q,data);
if(risk){
this.track('ai_note_blocked',{tool,deck:r.deck,spread:r.spread,reason:'safety'});
if(risk.text){
showStatusLinked(status,risk.text,risk.lang,risk.links);
}else{
status.removeAttribute('lang');
status.textContent='';
}
return;
}
const body=noteRequest(r,q,this._turnstileToken(),undefined);
if(!body)return;
this._busy=true;
btn.setAttribute('disabled','disabled');
this.track('ai_note_request',{tool,deck:r.deck,spread:r.spread});
let res=null;
try{
const f=(this._opts&&this._opts.fetchImpl)||globalThis.fetch;
res=await f(data.ai.endpoint,{
method:'POST',
headers:{'Content-Type':'application/json'},
credentials:'omit',
body:JSON.stringify(body),
});
}catch{
this._busy=false;
btn.removeAttribute('disabled');
this.track('ai_note_error',{tool,deck:r.deck,spread:r.spread});
status.removeAttribute('lang');
status.textContent=this.s('ai_note_error')||'';
return;
}
this._busy=false;
btn.removeAttribute('disabled');
let json=null;
try{json=await res.json();}catch{json=null;}
if(res.ok&&json&&typeof json.note==='string'&&json.note.trim()!==''){
const fromKey=typeof json.label_key==='string'?this.s(json.label_key):null;
const disclosure=this.s('ai_note_disclosure');
const label=fromKey||str(json.label)||str(data.ai.label)||disclosure;
if(!label){
status.removeAttribute('lang');
status.textContent=this.s('ai_note_error')||'';
return;
}
const labelIsDisclosure=label===disclosure&&!fromKey&&!str(json.label)&&!str(data.ai.label);
clear(out);
out.appendChild(el('p',{
cls:'df-rr-ai__label',
attrs:labelIsDisclosure?{lang:'en'}:null,
text:label,
}));
out.appendChild(el('p',{cls:'df-rr-ai__text',text:json.note}));
out.setAttribute('data-ai-generated','true');
out.removeAttribute('hidden');
status.removeAttribute('lang');
status.textContent='';
focusTo(out);
this.track('ai_note_shown',{tool,deck:r.deck,spread:r.spread});
return;
}
const reason=json&&typeof json.error==='string'?json.error:null;
const known=['limit','safety','filter','quota'];
status.removeAttribute('lang');
if(reason&&known.indexOf(reason)!==-1){
this.track('ai_note_blocked',{tool,deck:r.deck,spread:r.spread,reason});
status.textContent=this.s('ai_note_'+reason)||this.s('ai_note_error')||'';
}else{
this.track('ai_note_error',{tool,deck:r.deck,spread:r.spread});
status.textContent=this.s('ai_note_error')||'';
}
}
_turnstileToken(){
try{
const t=globalThis.turnstile;
if(t&&typeof t.getResponse==='function')return String(t.getResponse()||'');
}catch{}
return'';
}
};
}

return { "MAX_QUESTION": MAX_QUESTION, "noteRequest": noteRequest, "makeAiNoteEl": makeAiNoteEl };
})();

__m["table-el"] = (function () {
const{el,clear,line,linkedLine,clampGrid,clampRot,focusTo,busyNode}=__m["dom"];
const{inView}=__m["events"];
const{deferred,loadBundle,idlePrefetch}=__m["bundle"];
const{draw,fan,DECK_IDS,SPREAD_IDS,reversalsDefault}=__m["draw"];
const{compose}=__m["compose"];
const{isDecisionQuestion,needsTopic,isTopic}=__m["lean"];
const{safetyResponse,riskResponse}=__m["yesno"];
const{read,write,reversalsChoice,rememberReversals}=__m["storage"];
const{str,fill,deckName,displayNameOf}=__m["text"];
const{cardNode}=__m["card-node"];
const{offerableDecks,defaultDeck}=__m["cart"];
const REVERSAL_ATTR=['on','off'];
function makeTableEl(Base){
return class DFTable extends Base{
constructor(){
super();
this._deck=null;
this._spread=null;
this._reversals=false;
this._drawn=null;
this._reading=null;
this._stopView=null;
this._stopEnd=null;
this._idle=null;
this._topic=null;
this._topicFor=null;
this._revealed=null;
}
render(root){
clear(root);
const data=this.data;
this._locked=!!(this.data.flags&&this.data.flags.deck_locked===true);
const remembered=this._locked?{}:(read('table')||{});
const offerable=this._availableDecks();
const offered=(id)=>(typeof id==='string'&&offerable.some((d)=>d.deck_id===id))?id:null;
this._deck=offered(this.pick('deck',DECK_IDS,null))
||offered(remembered.deck)
||defaultDeck(data)
||null;
this._spread=this.pick('spread',SPREAD_IDS,null)
||(SPREAD_IDS.indexOf(remembered.spread)!==-1?remembered.spread:null)
||this._defaultSpread();
const revAttr=this.pick('reversals',REVERSAL_ATTR,null);
const herChoice=this._locked?null:reversalsChoice();
this._reversals=this._locked?false:revAttr?revAttr==='on'
:(herChoice===null?reversalsDefault(data):herChoice);
this._remember();
this._questionWrap=el('div',{cls:'df-rr-question-wrap'});
this._controls=el('div',{cls:'df-rr-controls'});
this._table=el('div',{cls:'df-rr-table'});
this._readingEl=el('div',{cls:'df-rr-reading',attrs:{tabindex:'-1'}});
this._after=el('div',{cls:'df-rr-after'});
root.appendChild(this._questionWrap);
root.appendChild(this._controls);
root.appendChild(this._table);
root.appendChild(this._readingEl);
root.appendChild(this._after);
this._questionEl=this.questionBox(this._questionWrap,'question_placeholder');
this.questionHelp(this._questionWrap,'question_help',this._questionEl);
this._topicWrap=el('div',{cls:'df-rr-topic-wrap'});
this._questionWrap.appendChild(this._topicWrap);
this._renderControls();
if(this._spread)this.track('spread_pick',{tool:'table',deck:this._deck,spread:this._spread});
if(this._deck)this.track('deck_pick',{tool:'table',deck:this._deck,spread:this._spread});
this._idle=idlePrefetch(this.data,this._opts);
this._stopView=inView(this,()=>{
this.track('tool_view',{tool:'table',deck:this._deck,spread:this._spread});
});
}
_defaultSpread(){
const list=(this.data.spreads||[]).filter((s)=>s&&SPREAD_IDS.indexOf(s.spread_id)!==-1);
for(const s of list)if(Number(s.count)>1)return s.spread_id;
return list[0]?list[0].spread_id:null;
}
_question(){
const q=this._questionEl;
return q&&typeof q.value==='string'?q.value:'';
}
_resolveTopic(question){
if(isTopic(this._topic)&&this._topicFor===question)return this._topic;
this._topic=null;
this._topicFor=null;
if(needsTopic(question,this.data))return false;
return null;
}
_renderTopicAsk(question){
clear(this._topicWrap);
const asked=this.topicChips(this._topicWrap,null,(t)=>{
this._topic=t;
this._topicFor=question;
clear(this._topicWrap);
this._shuffle();
});
return!!asked;
}
_availableDecks(){
return offerableDecks(this.data);
}
_spreadObj(id){
for(const s of(this.data.spreads||[]))if(s&&s.spread_id===(id||this._spread))return s;
return null;
}
_remember(){
if(this._locked)return;
write('table',{deck:this._deck,spread:this._spread});
}
_renderControls(){
clear(this._controls);
const deckLabel=this._locked?null:this.s('pick_deck');
if(deckLabel)this._controls.appendChild(el('p',{cls:'df-rr-label',attrs:{id:'df-rr-decklabel'},text:deckLabel}));
const deckGroup=el('div',{cls:'df-rr-picker',attrs:{role:'radiogroup','aria-labelledby':'df-rr-decklabel'}});
for(const d of(this._locked?[]:this._availableDecks())){
const on=d.deck_id===this._deck;
const b=el('button',{
cls:'df-rr-chip'+(on?' is-on':''),
attrs:{type:'button',role:'radio','aria-checked':on?'true':'false','data-deck':d.deck_id},
text:displayNameOf(d)||d.deck_id,
});
b.addEventListener('click',()=>{
this._deck=d.deck_id;
this._remember();
this.track('deck_pick',{tool:'table',deck:this._deck,spread:this._spread});
this._renderControls();
});
deckGroup.appendChild(b);
}
if(!this._locked)this._controls.appendChild(deckGroup);
const spreadLabel=this.s('pick_spread');
if(spreadLabel)this._controls.appendChild(el('p',{cls:'df-rr-label',attrs:{id:'df-rr-spreadlabel'},text:spreadLabel}));
const spreadGroup=el('div',{cls:'df-rr-picker',attrs:{role:'radiogroup','aria-labelledby':'df-rr-spreadlabel'}});
for(const s of(this.data.spreads||[])){
if(!s||SPREAD_IDS.indexOf(s.spread_id)===-1)continue;
const on=s.spread_id===this._spread;
const b=el('button',{
cls:'df-rr-chip'+(on?' is-on':''),
attrs:{type:'button',role:'radio','aria-checked':on?'true':'false','data-spread':s.spread_id},
text:str(s.name)||s.spread_id,
});
b.addEventListener('click',()=>{
this._spread=s.spread_id;
this._remember();
this.track('spread_pick',{tool:'table',deck:this._deck,spread:this._spread});
this._renderControls();
});
spreadGroup.appendChild(b);
}
this._controls.appendChild(spreadGroup);
const revLabel=this._locked?null:this.s('use_reversals');
if(revLabel){
const t=el('button',{
cls:'df-rr-toggle',
attrs:{type:'button',role:'switch','aria-checked':this._reversals?'true':'false'},
text:revLabel,
});
t.addEventListener('click',()=>{
this._reversals=!this._reversals;
rememberReversals(this._reversals);
this._renderControls();
});
this._controls.appendChild(t);
const revHint=line('p',this.s('reversals_hint'),'df-rr-toggle__hint');
if(revHint)this._controls.appendChild(revHint);
}
const shuffleLabel=this.s('shuffle');
if(shuffleLabel){
const b=el('button',{cls:'df-rr-btn df-rr-shuffle',attrs:{type:'button'},text:shuffleLabel});
b.addEventListener('click',()=>this._shuffle());
this._controls.appendChild(b);
}
}
_shuffle(){
const spread=this._spreadObj();
if(!spread)return;
const question=this._question();
const safety=safetyResponse(question,this.data);
if(safety){
this._gen=(this._gen||0)+1;
this._renderSafety(safety);
return;
}
if(!riskResponse(question,this.data)&&this._askTopicIfNeeded(question))return;
clear(this._topicWrap);
this.track('draw_start',{tool:'table',deck:this._deck,spread:this._spread});
this.fire('df-tier-b');
this._picks=[];
this._seed=null;
this._renderFan(spread);
clear(this._readingEl);
clear(this._after);
}
_askTopicIfNeeded(question){
if(this._resolveTopic(question)!==false)return false;
clear(this._table);
clear(this._readingEl);
clear(this._after);
if(!this._renderTopicAsk(question))return false;
focusTo(this._topicWrap);
return true;
}
_renderSafety(safety){
clear(this._table);
clear(this._readingEl);
clear(this._after);
clear(this._topicWrap);
if(safety.text){
const p=linkedLine('p',safety.text,safety.kind==='crisis'?'df-rr-table__help':'df-rr-table__unavailable',safety.links);
if(p){
p.setAttribute('lang',safety.lang);
this._readingEl.appendChild(p);
}
}
focusTo(this._readingEl);
}
_renderFan(spread){
clear(this._table);
const drawn=draw(spread,this._deck,{reversals:this._reversals});
this._pending=drawn;
const order=fan(drawn.seed,this._deck);
const fanEl=el('div',{cls:'df-rr-fan',attrs:{role:'group','aria-label':this.s('fan_label')||'cards'}});
const need=spread.count;
const chosen=[];
for(let i=0;i<order.length;i++){
const b=el('button',{
cls:'df-rr-back',
attrs:{type:'button','data-slot':String(i),'aria-pressed':'false'},
text:String(i+1),
});
b.addEventListener('click',()=>{
const at=chosen.indexOf(i);
if(at!==-1){chosen.splice(at,1);b.setAttribute('aria-pressed','false');}
else if(chosen.length<need){chosen.push(i);b.setAttribute('aria-pressed','true');}
if(chosen.length===need)this._reveal(spread,drawn.seed,chosen.slice());
});
fanEl.appendChild(b);
}
this._table.appendChild(fanEl);
const autoLabel=this.s('draw_for_me');
if(autoLabel){
const b=el('button',{cls:'df-rr-btn df-rr-auto',attrs:{type:'button'},text:autoLabel});
b.addEventListener('click',()=>this._reveal(spread,drawn.seed,null));
this._table.appendChild(b);
}
}
_reveal(spread,seed,picks){
const data=this.data;
const questionEl=this._questionEl;
const question=questionEl&&typeof questionEl.value==='string'?questionEl.value:'';
this._gen=(this._gen||0)+1;
const gen=this._gen;
const safety=safetyResponse(question,data);
if(safety){
this._renderSafety(safety);
return;
}
if(!riskResponse(question,data)&&this._askTopicIfNeeded(question))return;
this._risk=riskResponse(question,data);
if(deferred(data)){
clear(this._table);
const busy=el('div',{cls:'df-rr-table__loading',attrs:{'aria-busy':'true'}});
busy.appendChild(busyNode());
this._table.appendChild(busy);
loadBundle(data,this._opts).then(()=>{
if(!this.mounted||gen!==this._gen)return;
this._doReveal(spread,seed,picks,question,gen);
});
return;
}
this._doReveal(spread,seed,picks,question,gen);
}
_doReveal(spread,seed,picks,question,gen){
const opts={seed,reversals:this._reversals};
if(picks)opts.picks=picks;
const drawn=draw(spread,this._deck,opts);
this._drawn=drawn;
const topic=isTopic(this._topic)&&this._topicFor===question?this._topic:null;
const reading=compose(drawn,this.data,{question,topic});
this._reading=reading;
clear(this._table);
const layout=el('div',{cls:'df-rr-layout'});
const reveal=this._make('df-reveal');
const nodes=[];
const names=[];
reading.positions.forEach((p,i)=>{
const byKey=(spread.positions||[]).findIndex((q)=>q&&str(q.key)===p.key);
const pos=(spread.positions&&spread.positions[byKey!==-1?byKey:i])||{};
const card=cardNode(this.data,{
cardId:p.card_id,
deck:this._deck,
reversed:p.reversed,
size:'225',
style:`--df-x:${clampGrid(pos.x)};--df-y:${clampGrid(pos.y)};--df-rot:${clampRot(pos.rot)}deg`,
});
if(!card)return;
nodes.push(card);
names.push(p.name);
});
layout.appendChild(reveal);
this._table.appendChild(layout);
reveal.mountWith(this.data,this._opts);
for(const n of nodes)n.mountWith(this.data,this._opts);
reveal.setCards(nodes);
const reversedCount=reading.positions.filter((p)=>p.reversed).length;
this._reversedCount=reversedCount;
const revealKey=String(seed)+'|'+this._spread+'|'+this._deck;
if(this._revealed!==revealKey){
this._revealed=revealKey;
this.track('reveal',{tool:'table',deck:this._deck,spread:this._spread,reversed_count:reversedCount});
}
reveal.reveal(names,()=>{
if(!this.mounted||gen!==this._gen)return;
this._renderReading(reading);
focusTo(this._readingEl);
});
}
_make(tag){
const d=globalThis.document;
return d.createElement(tag);
}
_renderReading(r){
clear(this._readingEl);
clear(this._after);
if(this._risk&&this._risk.text){
const p=linkedLine('p',this._risk.text,'df-rr-table__risk',this._risk.links);
if(p){
p.setAttribute('lang',this._risk.lang);
this._readingEl.appendChild(p);
}
}
const readFor=this.readForLine(r.topic);
if(readFor)this._readingEl.appendChild(readFor);
const head=line('p',r.headline,'df-rr-headline');
if(head)this._readingEl.appendChild(head);
const whyText=r.lean&&str(r.lean.why);
if(whyText&&!(r.headline&&r.headline.indexOf(whyText)!==-1)){
const why=line('p',whyText,'df-rr-why');
if(why)this._readingEl.appendChild(why);
}
const list=el('ol',{cls:'df-rr-positions'});
for(const p of r.positions){
const li=el('li',{cls:'df-rr-position',attrs:{'data-key':p.key}});
const asks=line('p',p.asks,'df-rr-position__asks');
if(asks)li.appendChild(asks);
const note=line('p',p.note,'df-rr-position__note');
if(note)li.appendChild(note);
const heading=line('h3',p.name,'df-rr-position__name');
if(heading)li.appendChild(heading);
const meaning=line('p',p.meaning,'df-rr-position__meaning');
if(meaning)li.appendChild(meaning);
const gloss=line('p',p.gloss,'df-rr-position__gloss');
if(gloss)li.appendChild(gloss);
const body=line('p',p.body,'df-rr-position__body');
if(body)li.appendChild(body);
const lens=line('p',p.lens,'df-rr-position__lens');
if(lens)li.appendChild(lens);
const look=line('p',p.look_q,'df-rr-position__look');
if(look){
li.appendChild(look);
inView(look,()=>this.track('look_q_view',{tool:'table',deck:r.deck,spread:r.spread}));
}
list.appendChild(li);
}
this._readingEl.appendChild(list);
const not=line('p',r.not_saying,'df-rr-notsaying');
if(not){
const notTitle=line('p',this.s('not_saying_title'),'df-rr-notsaying__title df-rr-label');
if(notTitle)this._readingEl.appendChild(notTitle);
this._readingEl.appendChild(not);
}
const action=line('p',r.action,'df-rr-action');
if(action){
const actionTitle=line('p',this.s('action_title'),'df-rr-action__title df-rr-label');
if(actionTitle)this._readingEl.appendChild(actionTitle);
this._readingEl.appendChild(action);
}
const endAnchor=action||not||head;
if(endAnchor){
if(this._stopEnd)this._stopEnd();
this._stopEnd=inView(endAnchor,()=>{
this.track('reading_end',{
tool:'table',deck:r.deck,spread:r.spread,reversed_count:this._reversedCount,
});
});
}
const y=this._make('df-read-it-yourself');
this._after.appendChild(y);
y.mountWith(this.data,this._opts);
y.setReading(r);
if(r.learn.length){
const ul=el('ul',{cls:'df-rr-learn'});
for(const l of r.learn){
const a=el('a',{cls:'df-rr-learn__link',attrs:{href:l.url},text:l.label});
a.addEventListener('click',()=>this.track('learn_click',{tool:'table',deck:r.deck,spread:r.spread}));
ul.appendChild(el('li',null,[a]));
}
this._after.appendChild(ul);
}
if(this.data.flags&&this.data.flags.ai_notes===true&&this.data.ai){
const ai=this._make('df-ai-note');
ai.setAttribute('tool','table');
this._after.appendChild(ai);
ai.mountWith(this.data,this._opts);
ai.setReading(r);
}
const handoff=line('p',fill(this.s('deck_handoff'),{deck:deckName(this.data,r.deck)}),'df-rr-handoff');
if(handoff)this._after.appendChild(handoff);
const offer=this._make('df-deck-offer');
offer.setAttribute('deck',r.deck);
offer.setAttribute('tool','table');
this._after.appendChild(offer);
offer.mountWith(this.data,this._opts);
const again=this.s('draw_again');
if(again){
const b=el('button',{cls:'df-rr-btn df-rr-again',attrs:{type:'button'},text:again});
b.addEventListener('click',()=>this._shuffle());
this._after.appendChild(b);
}
const caution=line('p',r.caution_line,'df-rr-caution');
if(caution)this._after.appendChild(caution);
this.fire('df-reading',{spread:r.spread,deck:r.deck});
}
reading(){return this._reading;}
leansOn(question){return isDecisionQuestion(question,this.data);}
destroy(){
if(this._stopView)this._stopView();
if(this._stopEnd)this._stopEnd();
if(this._idle)this._idle();
super.destroy();
}
};
}

return { "makeTableEl": makeTableEl };
})();

__m["yes-no-el"] = (function () {
const{el,clear,line,linkedLine,focusTo,liveRegion,say,busyNode}=__m["dom"];
const{inView}=__m["events"];
const{deferred,loadBundle,idlePrefetch}=__m["bundle"];
const{draw,reversalsDefault}=__m["draw"];
const{yesNo,safetyResponse,riskResponse}=__m["yesno"];
const{needsTopic,isTopic}=__m["lean"];
const{DECK_IDS}=__m["draw"];
const{own,str,fill,deckName}=__m["text"];
const{localPath}=__m["compose"];
const{reversalsChoice}=__m["storage"];
const{cardNode}=__m["card-node"];
const{offerableDecks,defaultDeck}=__m["cart"];
function findByClass(node,cls){
if(!node)return null;
const c=node.getAttribute&&node.getAttribute('class');
if(typeof c==='string'&&c.split(' ').indexOf(cls)!==-1)return node;
for(const k of node.childNodes||[]){
const hit=findByClass(k,cls);
if(hit)return hit;
}
return null;
}
function makeYesNoEl(Base){
return class DFYesNo extends Base{
constructor(){
super();
this._stop=null;
this._idle=null;
this._stopEnd=null;
this._topic=null;
this._topicFor=null;
this._revealed=null;
}
render(root){
clear(root);
const data=this.data;
const offerable=offerableDecks(data);
const attrDeck=this.pick('deck',DECK_IDS,null);
this._deck=(attrDeck&&offerable.some((d)=>d.deck_id===attrDeck))?attrDeck:defaultDeck(data);
this._out=el('div',{cls:'df-rr-yn',attrs:{tabindex:'-1'}});
this._live=liveRegion();
this._questionWrap=el('div',{cls:'df-rr-question-wrap'});
root.appendChild(this._questionWrap);
this._questionEl=this.questionBox(this._questionWrap,'question_placeholder');
this.questionHelp(this._questionWrap,'question_help',this._questionEl);
this._topicWrap=el('div',{cls:'df-rr-topic-wrap'});
this._questionWrap.appendChild(this._topicWrap);
const server=this.adopted('ask');
const ask=this.s('ask_yes_no');
if(server){
this.wire(server,'click',()=>this._draw());
}else if(ask){
const b=el('button',{cls:'df-rr-btn df-rr-yn__ask',attrs:{type:'button'},text:ask});
b.addEventListener('click',()=>this._draw());
root.appendChild(b);
}else{
throw new Error('df-rr: <df-yes-no> has no way to ask — the page carries no '
+'`strings.ask_yes_no` and no server-rendered [data-rr-ask] control in its light DOM. '
+'Ship one of the two; the server-rendered one costs no layout shift (contract #19).');
}
root.appendChild(this._out);
root.appendChild(this._live);
this._idle=idlePrefetch(data,this._opts);
this._stop=inView(this,()=>this.track('tool_view',{tool:'yes-no',deck:this._deck,spread:'yes-no'}));
this.track('spread_pick',{tool:'yes-no',deck:this._deck,spread:'yes-no'});
if(this._deck)this.track('deck_pick',{tool:'yes-no',deck:this._deck,spread:'yes-no'});
}
_question(){
const q=this._questionEl;
return q&&typeof q.value==='string'?q.value:'';
}
_resolveTopic(question){
if(isTopic(this._topic)&&this._topicFor===question)return this._topic;
this._topic=null;
this._topicFor=null;
if(needsTopic(question,this.data))return false;
return null;
}
_askTopicIfNeeded(question){
if(this._resolveTopic(question)!==false)return false;
clear(this._out);
clear(this._topicWrap);
const asked=this.topicChips(this._topicWrap,null,(t)=>{
this._topic=t;
this._topicFor=question;
clear(this._topicWrap);
this._draw();
});
if(!asked)return false;
focusTo(this._topicWrap);
return true;
}
_spread(){
for(const s of(this.data.spreads||[]))if(s&&s.spread_id==='yes-no')return s;
return{spread_id:'yes-no',count:1,question_type:'yes_no',positions:[{key:'answer',x:6,y:6}]};
}
_draw(){
const data=this.data;
const questionEl=this._questionEl;
const question=questionEl&&typeof questionEl.value==='string'?questionEl.value:'';
this._gen=(this._gen||0)+1;
const gen=this._gen;
clear(this._out);
const safety=safetyResponse(question,data);
if(safety){
if(safety.text){
const p=linkedLine('p',safety.text,safety.kind==='crisis'?'df-rr-yn__help':'df-rr-yn__unavailable',safety.links);
if(p){
p.setAttribute('lang',safety.lang);
this._out.appendChild(p);
}
}
focusTo(this._out);
return;
}
if(!riskResponse(question,data)&&this._askTopicIfNeeded(question))return;
clear(this._topicWrap);
this.track('draw_start',{tool:'yes-no',deck:this._deck,spread:'yes-no'});
if(deferred(data)){
this._out.setAttribute('aria-busy','true');
this._out.appendChild(busyNode());
loadBundle(data,this._opts).then(()=>{
if(!this.mounted||gen!==this._gen)return;
this._out.removeAttribute('aria-busy');
clear(this._out);
this._reveal(question);
});
return;
}
this._reveal(question);
}
_reveal(question){
const data=this.data;
const herChoice=reversalsChoice();
const reversals=herChoice===null?reversalsDefault(data):herChoice;
const drawn=draw(this._spread(),this._deck,{reversals});
const c=drawn.cards[0];
const topic=isTopic(this._topic)&&this._topicFor===question?this._topic:null;
const answer=yesNo(c.card_id,c.reversed,data,question,{topic});
if(!answer)return;
const card=own(data.cards,c.card_id)||{};
const risk=riskResponse(question,data);
if(risk&&risk.text){
const p=linkedLine('p',risk.text,'df-rr-yn__risk',risk.links);
if(p){
p.setAttribute('lang',risk.lang);
this._out.appendChild(p);
}
}
const readFor=!risk?this.readForLine(answer.topic):null;
if(readFor)this._out.appendChild(readFor);
const label=!risk&&answer.verdict?this.s('verdict.'+answer.verdict):null;
if(label){
this._out.appendChild(el('p',{
cls:'df-rr-yn__verdict',
attrs:{'data-verdict':answer.verdict},
text:label,
}));
}
const cardEl=cardNode(data,{cardId:c.card_id,deck:this._deck,reversed:c.reversed});
if(cardEl){
this._out.appendChild(cardEl);
cardEl.mountWith(data,this._opts);
}
const meaning=line('p',str(c.reversed?card.common_meaning_rev:card.common_meaning),'df-rr-yn__meaning');
if(meaning)this._out.appendChild(meaning);
if(!risk){
const reason=line('p',answer.reason,'df-rr-yn__reason');
if(reason)this._out.appendChild(reason);
const look=line('p',answer.look_q,'df-rr-yn__look');
if(look){
this._out.appendChild(look);
inView(look,()=>this.track('look_q_view',{tool:'yes-no',deck:this._deck,spread:'yes-no'}));
}
const action=line('p',answer.action,'df-rr-yn__action');
if(action){
const actionTitle=line('p',this.s('action_title'),'df-rr-yn__action-title df-rr-label');
if(actionTitle)this._out.appendChild(actionTitle);
this._out.appendChild(action);
}
const url=localPath(card.article_url);
const readMore=this.s('read_the_card');
if(url&&readMore){
const a=el('a',{cls:'df-rr-learn__link',attrs:{href:url},text:readMore});
a.addEventListener('click',()=>this.track('learn_click',{tool:'yes-no',deck:this._deck,spread:'yes-no'}));
this._out.appendChild(a);
}
const handoff=line('p',fill(this.s('deck_handoff'),{deck:deckName(data,this._deck)}),'df-rr-handoff');
if(handoff)this._out.appendChild(handoff);
const offer=globalThis.document.createElement('df-deck-offer');
offer.setAttribute('deck',this._deck);
offer.setAttribute('tool','yes-no');
this._out.appendChild(offer);
offer.mountWith(data,this._opts);
}
const reversedCount=c.reversed?1:0;
const revealKey=String(drawn.seed)+'|'+this._deck;
if(this._revealed!==revealKey){
this._revealed=revealKey;
this.track('reveal',{tool:'yes-no',deck:this._deck,spread:'yes-no',reversed_count:reversedCount});
}
const endAnchor=this._endAnchor();
if(endAnchor){
if(this._stopEnd)this._stopEnd();
this._stopEnd=inView(endAnchor,()=>{
this.track('reading_end',{
tool:'yes-no',deck:this._deck,spread:'yes-no',reversed_count:reversedCount,
});
});
}
say(this._live,[str(card.name),label].filter(Boolean).join(' — '));
focusTo(this._out);
this.fire('df-reading',{verdict:risk?null:answer.verdict,card_id:c.card_id,reversed:c.reversed});
}
_endAnchor(){
for(const cls of['df-rr-yn__action','df-rr-yn__meaning','df-rr-yn__verdict']){
const n=findByClass(this._out,cls);
if(n)return n;
}
return null;
}
destroy(){
if(this._stop)this._stop();
if(this._stopEnd)this._stopEnd();
if(this._idle)this._idle();
super.destroy();
}
};
}

return { "makeYesNoEl": makeYesNoEl };
})();

__m["daily-el"] = (function () {
const{el,clear,line,focusTo}=__m["dom"];
const{inView}=__m["events"];
const{deferred,loadBundle,idlePrefetch}=__m["bundle"];
const{heightFor}=__m["daily-heights"];
const{daily,localDate}=__m["daily"];
const{DECK_IDS}=__m["draw"];
const{own,str,fill,deckName,wordOverlap}=__m["text"];
const{localPath}=__m["compose"];
const{read,write,available}=__m["storage"];
const{cardNode}=__m["card-node"];
const{offerableDecks,defaultDeck}=__m["cart"];
const FOCUS=Object.freeze(['love','work','decision','self']);
function focusLine(card,focus,reversed){
if(!card)return null;
if(focus==='love')return str(reversed?card.love_rev:card.love_line)||str(card.love_line);
if(focus==='work')return str(reversed?card.work_rev:card.work_line)||str(card.work_line);
if(focus==='decision')return str(card.decision_q);
if(focus==='self')return str(card.self_q);
return str(reversed?card.core_rev_plain:card.core_up);
}
function practiceLine(card,focus){
if(!card)return null;
const key=focus==='love'?'practice_love'
:focus==='work'?'practice_work'
:focus==='decision'?'practice_decision'
:focus==='self'?'practice_self'
:null;
return(key?str(own(card,key)):null)||str(card.practice);
}
function coreLine(card,reversed){
if(!card)return null;
return str(reversed?card.core_rev_plain:card.core_up);
}
function structureLine(card){
return str(card&&card.structure_line);
}
function dailyDateLine(dateStr,lang){
if(typeof dateStr!=='string'||!/^\d{4}-\d{2}-\d{2}$/.test(dateStr))return null;
const d=new Date(dateStr+'T00:00:00');
if(Number.isNaN(d.getTime()))return null;
try{
return new Intl.DateTimeFormat(lang,{weekday:'long',day:'numeric',month:'long'}).format(d);
}catch{
return null;
}
}
function universalLookQ(card){
const list=Array.isArray(card&&card.look_q)?card.look_q:[];
const flags=Array.isArray(card&&card.look_q_universal)?card.look_q_universal:[];
for(let i=0;i<list.length;i++){
if(flags[i]!==true)continue;
const q=str(list[i]);
if(q)return q;
}
return null;
}
function makeDailyEl(Base){
return class DFDailyCard extends Base{
constructor(){
super();
this._stop=null;
this._focus=null;
this._idle=null;
this._stopEnd=null;
this._revealed=null;
this._endFired=null;
}
render(root){
clear(root);
const data=this.data;
const offerable=offerableDecks(data);
const attrDeck=this.pick('deck',DECK_IDS,null);
this._deck=(attrDeck&&offerable.some((d)=>d.deck_id===attrDeck))?attrDeck:defaultDeck(data);
if(!this._deck)return;
this._tap=el('div',{cls:'df-rr-daily__tap'});
this._out=el('div',{cls:'df-rr-daily',attrs:{tabindex:'-1'}});
root.appendChild(this._tap);
root.appendChild(this._out);
this._renderTap();
this._renderCard();
this._idle=idlePrefetch(data,this._opts);
this._stop=inView(this,()=>this.track('tool_view',{tool:'daily',deck:this._deck}));
this.track('spread_pick',{tool:'daily',deck:this._deck,spread:'one-card'});
this.track('deck_pick',{tool:'daily',deck:this._deck,spread:'one-card'});
}
_renderTap(){
clear(this._tap);
const prompt=this.s('daily_focus_prompt');
if(!prompt)return;
this._tap.appendChild(el('p',{cls:'df-rr-label',attrs:{id:'df-rr-focuslabel'},text:prompt}));
const group=el('div',{cls:'df-rr-picker',attrs:{role:'radiogroup','aria-labelledby':'df-rr-focuslabel'}});
for(const f of FOCUS){
const label=this.s('daily_focus_'+f);
if(!label)continue;
const on=this._focus===f;
const b=el('button',{
cls:'df-rr-chip'+(on?' is-on':''),
attrs:{type:'button',role:'radio','aria-checked':on?'true':'false'},
text:label,
});
b.addEventListener('click',()=>{
this._focus=this._focus===f?null:f;
this._renderTap();
this._renderCard();
});
group.appendChild(b);
}
if(group.childNodes.length)this._tap.appendChild(group);
}
_renderCard(){
const data=this.data;
const today=localDate(this._opts&&this._opts.now instanceof Date?this._opts.now:undefined);
const stored=read('daily');
const result=daily(today,this._deck,data,{stored});
const h=heightFor(result.card_id,globalThis.innerWidth);
if(h)this.setAttribute('style','min-height:'+h+'px');
this._doRenderCard(result);
if(deferred(data)){
loadBundle(data,this._opts).then(()=>{
if(!this.alive)return;
this._doRenderCard(result);
});
}
}
_doRenderCard(result){
const data=this.data;
const deck=this._deck;
clear(this._out);
if(result.fresh)write('daily',{date:result.date,card_id:result.card_id,reversed:result.reversed});
const card=own(data.cards,result.card_id)||{};
const dateLine=line('p',dailyDateLine(result.date,data.lang),'df-rr-daily__date');
if(dateLine)this._out.appendChild(dateLine);
const cardEl=cardNode(data,{cardId:result.card_id,deck,reversed:result.reversed});
if(cardEl){
this._out.appendChild(cardEl);
cardEl.mountWith(data,this._opts);
}
const meaning=line('p',str(result.reversed?card.common_meaning_rev:card.common_meaning),'df-rr-daily__meaning');
if(meaning)this._out.appendChild(meaning);
const focusText=focusLine(card,this._focus,result.reversed);
const focused=line('p',focusText,'df-rr-daily__focus');
if(focused)this._out.appendChild(focused);
const coreText=coreLine(card,result.reversed);
const coreRepeats=coreText&&focusText&&wordOverlap(coreText,focusText)>=0.5;
const core=coreRepeats?null:line('p',coreText,'df-rr-daily__core');
if(core)this._out.appendChild(core);
const structure=line('p',structureLine(card),'df-rr-daily__structure');
if(structure)this._out.appendChild(structure);
const practice=line('p',practiceLine(card,this._focus),'df-rr-daily__practice');
if(practice){
const practiceTitle=line('p',this.s('daily_practice_title'),'df-rr-daily__practice-title df-rr-label');
if(practiceTitle)this._out.appendChild(practiceTitle);
this._out.appendChild(practice);
}
const look=line('p',universalLookQ(card),'df-rr-daily__look');
if(look){
this._out.appendChild(look);
inView(look,()=>this.track('look_q_view',{tool:'daily',deck}));
}
const caution=line('p',str(card.caution),'df-rr-daily__caution');
if(caution){
const cautionTitle=line('p',this.s('daily_caution_title'),'df-rr-daily__caution-title df-rr-label');
if(cautionTitle)this._out.appendChild(cautionTitle);
this._out.appendChild(caution);
}
const url=localPath(card.article_url);
const readMore=this.s('read_the_card');
if(url&&readMore){
const a=el('a',{cls:'df-rr-learn__link',attrs:{href:url},text:readMore});
a.addEventListener('click',()=>this.track('learn_click',{tool:'daily',deck}));
this._out.appendChild(a);
}
const handoff=line('p',fill(this.s('deck_handoff'),{deck:deckName(data,deck)}),'df-rr-handoff');
if(handoff)this._out.appendChild(handoff);
const offer=globalThis.document.createElement('df-deck-offer');
offer.setAttribute('deck',deck);
offer.setAttribute('tool','daily');
this._out.appendChild(offer);
offer.mountWith(data,this._opts);
const back=this.s('come_back_tomorrow');
if(back)this._out.appendChild(el('p',{cls:'df-rr-daily__tomorrow',text:back}));
if(!available()){
const warn=this.s('storage_blocked');
if(warn)this._out.appendChild(el('p',{cls:'df-rr-daily__nostore',text:warn}));
}
const readingKey=result.date+'|'+result.card_id+'|'+(result.reversed?'r':'u');
if(this._revealed!==readingKey){
this._revealed=readingKey;
this.track('reveal',{tool:'daily',deck,reversed_count:result.reversed?1:0});
}
const endAnchor=practice||meaning||cardEl;
if(endAnchor){
if(this._stopEnd)this._stopEnd();
this._stopEnd=inView(endAnchor,()=>{
if(this._endFired===readingKey)return;
this._endFired=readingKey;
this.track('reading_end',{tool:'daily',deck,reversed_count:result.reversed?1:0});
});
}
if(result.fresh)focusTo(this._out);
this.fire('df-reading',{card_id:result.card_id,reversed:result.reversed,date:result.date});
}
destroy(){
if(this._stop)this._stop();
if(this._stopEnd)this._stopEnd();
if(this._idle)this._idle();
super.destroy();
}
};
}

return { "FOCUS": FOCUS, "focusLine": focusLine, "practiceLine": practiceLine, "coreLine": coreLine, "structureLine": structureLine, "dailyDateLine": dailyDateLine, "universalLookQ": universalLookQ, "makeDailyEl": makeDailyEl };
})();

__m["birth-cards-el"] = (function () {
const{el,clear,line,focusTo,busyNode}=__m["dom"];
const{inView}=__m["events"];
const{deferred,loadBundle,idlePrefetch}=__m["bundle"];
const{birthCards,birthCardSteps}=__m["birth-cards"];
const{daysInMonth}=__m["dates"];
const{own,str,fill,deckName,displayNameOf}=__m["text"];
const{localPath}=__m["compose"];
const{DECK_IDS}=__m["draw"];
const{cardNode}=__m["card-node"];
const{offerableDecks,defaultDeck,deckOf,inStock,nextInStock,offerAdd}=__m["cart"];
const{paragraphs,words}=__m["prose"];
const{read,write,rememberBirthDate,birthDateRemembered,returnedFromForm}=__m["storage"];
const{yearCard,inWrittenRange}=__m["personal-year"];
const{reserveFor}=__m["birth-heights"];
const WORD_CAP=650;
const REVEAL_OFFSET=24;
const CARD_SLUG=Object.freeze({
'major-00':'FOOL','major-01':'MAGICIAN','major-02':'PRIESTESS','major-03':'EMPRESS',
'major-04':'EMPEROR','major-05':'HIEROPHANT','major-06':'LOVERS','major-07':'CHARIOT',
'major-08':'STRENGTH','major-09':'HERMIT','major-10':'WHEEL','major-11':'JUSTICE',
'major-12':'HANGED','major-13':'DEATH','major-14':'TEMPERANCE','major-15':'DEVIL',
'major-16':'TOWER','major-17':'STAR','major-18':'MOON','major-19':'SUN',
'major-20':'JUDGEMENT','major-21':'WORLD',
});
function birthdayCode(cardIds){
if(!Array.isArray(cardIds)||!cardIds.length)return null;
const parts=[];
for(const id of cardIds){
const slug=own(CARD_SLUG,id);
if(typeof slug!=='string')return null;
parts.push(slug);
}
return'BIRTH-'+parts.join('-');
}
const BIRTH_LABEL_KEYS=Object.freeze([
'what_are','your_cards','who_you_are','where_from','method_sum',
'in_love','in_work','another_date','year_card_title','year_card_teaser',
'enlarge','see_deck',
'why_heading','why_body','strip_line',
]);
const CARD_LINES=Object.freeze([
['love_line','in_love'],
['work_line','in_work'],
]);
function birthArithmeticChain(y,m,d,r){
const steps=birthCardSteps(y,m,d);
if(!steps.length||steps[0].kind!=='add')return null;
const folds=steps.slice(1).map((s)=>s.a+' + '+s.b+' = '+s.to);
const last=steps[steps.length-1].to;
if(r.primary===19){
let n=last;
while(n>9){
const a=Math.floor(n / 10),b=n%10,to=a+b;
folds.push(a+' + '+b+' = '+to);
n=to;
}
}else if(r.secondary!==null){
folds.push(Math.floor(last / 10)+' + '+(last%10)+' = '+r.secondary);
}
const rest=folds.length?' → '+folds.join(' → '):'';
return steps[0].parts.join(' + ')+' = '+steps[0].to+rest;
}
function sized(v,keys){
if(typeof v==='string')return str(v);
if(!v||typeof v!=='object')return null;
for(const k of keys){
const hit=str(own(v,k));
if(hit)return hit;
}
return null;
}
function coverBox(deck,size){
const square={width:String(size),height:String(size)};
const table=deck?own(deck,'cover_size'):null;
const pair=table?own(table,String(size)):null;
if(Array.isArray(pair)&&pair.length===2
&&Number.isFinite(Number(pair[0]))&&Number.isFinite(Number(pair[1]))
&&Number(pair[0])>0&&Number(pair[1])>0){
const w=Number(pair[0]),h=Number(pair[1]);
return{width:String(size),height:String(Math.round(size*(h / w)))};
}
return square;
}
function deckChipImage(deck){
if(!deck)return null;
return sized(deck.cover,['300','600'])
||(deck.product?str(deck.product.photo):null)
||sized(deck.back,['225','450']);
}
function triple(v){
if(!Array.isArray(v)||v.length!==3)return null;
const out=v.map(str);
return out.every((s)=>s!==null)?out:null;
}
function normaliseBirthReading(raw){
const none={
body:null,theme:null,gifts:null,challenges:null,advice:null,asks:null,action:null,
gift_notes:null,challenge_notes:null,
};
if(typeof raw==='string')return Object.assign({},none,{theme:str(raw)});
if(!raw||typeof raw!=='object'||Array.isArray(raw))return none;
return{
body:str(own(raw,'body')),
theme:str(own(raw,'theme')),
gifts:triple(own(raw,'gifts')),
challenges:triple(own(raw,'challenges')),
advice:triple(own(raw,'advice')),
asks:str(own(raw,'asks')),
action:str(own(raw,'action')),
gift_notes:triple(own(raw,'gift_notes')),
challenge_notes:triple(own(raw,'challenge_notes')),
};
}
const GLANCE=[
['gifts','birth_gifts_label'],
['challenges','birth_challenges_label'],
];
function pairKeyFromParts(primary,secondary,tertiary){
if(tertiary!==null&&tertiary!==undefined)return primary+'-'+secondary+'-'+tertiary;
if(secondary!==null&&secondary!==undefined)return primary+'-'+secondary;
return String(primary);
}
function readBirthReading(strings,ids){
const none={body:null,theme:null,gifts:null,challenges:null,advice:null,asks:null,action:null};
const birth=strings&&typeof strings==='object'?own(strings,'birth'):undefined;
if(!birth||typeof birth!=='object')return{reading:none,shape:null};
const readings=own(birth,'readings');
if(readings&&typeof readings==='object'){
const pairRaw=own(readings,pairKeyFromParts(ids.primary,ids.secondary,ids.tertiary));
if(pairRaw!==undefined&&pairRaw!==null){
return{reading:normaliseBirthReading(pairRaw),shape:'readings.pair'};
}
}
const primaryRaw=own(birth,String(ids.primary));
if(primaryRaw!==undefined&&primaryRaw!==null){
return{reading:normaliseBirthReading(primaryRaw),shape:'primary'};
}
return{reading:none,shape:null};
}
function makeBirthCardsEl(Base){
return class DFBirthCards extends Base{
constructor(){
super();
this._stop=null;
this._idle=null;
this._stopEnd=null;
this._stopYear=null;
this._revealed=null;
this._endFired=null;
this._yearFired=null;
this._chips=[];
this._shown=null;
this._emailWired=false;
this._panels=[];
this._go=null;
this._gate=false;
this._pickerInserted=false;
this._stripEl=null;
}
bs(key){
return this.s('birth.'+key)||this.s('birth_'+key);
}
render(root){
clear(root);
const data=this.data;
const remembered=read('birth')||{};
const offerable=this._availableDecks();
const offered=(id)=>(typeof id==='string'&&offerable.some((d)=>d.deck_id===id))?id:null;
const pinned=offered(this.pick('deck',DECK_IDS,null))||offered(remembered.deck);
this._deck=pinned||(offerable.length<2?defaultDeck(data):null);
this._idle=idlePrefetch(data,this._opts);
const serverGo=this.adopted('birth-go');
const serverD=this.adopted('bd')||this.adoptedById('rr-bd');
const serverM=this.adopted('bm')||this.adoptedById('rr-bm');
const serverY=this.adopted('by')||this.adoptedById('rr-by');
const wantsForm=!!(this.adopted('birth-form')||serverGo||serverD||serverM||serverY);
if(wantsForm&&!(serverGo&&serverD&&serverM&&serverY)){
const missing=[];
if(!serverGo)missing.push('[data-rr-birth-go] (or nothing matched)');
if(!serverD)missing.push('[data-rr-bd] or id="rr-bd"');
if(!serverM)missing.push('[data-rr-bm] or id="rr-bm"');
if(!serverY)missing.push('[data-rr-by] or id="rr-by"');
throw new Error('df-rr: <df-birth-cards> found a server-rendered form ([data-rr-birth-form]) '
+'but it is missing: '+missing.join(', ')+'. Fix the template rather than letting this '
+'tool build its own — adopting is what costs no layout shift (contract #19).');
}
this._top=el('div',{cls:'df-rr-birth__top'});
if(this._adopted&&this._adopted.length)this.insertBefore(this._top,this._adopted[0]);
else root.appendChild(this._top);
this._renderIntro(this._top);
this._renderWhy(this._top);
this._pickerWrap=el('div',{cls:'df-rr-birth__pickerwrap'});
if(serverGo&&serverD&&serverM&&serverY){
this._d=serverD;this._m=serverM;this._y=serverY;
this._err=this.adopted('birth-error')
||el('p',{cls:'df-rr-birth__error',attrs:{'aria-live':'polite'}});
this.wire(serverGo,'click',()=>this._show());
this._go=serverGo;
const parent=serverGo.parentNode;
if(parent&&typeof parent.insertBefore==='function'){
parent.insertBefore(this._pickerWrap,serverGo);
this._pickerInserted=true;
}else{
root.appendChild(this._pickerWrap);
}
}else{
const form=el('div',{cls:'df-rr-birth__form'});
this._d=this._field(form,'day',1,31);
this._m=this._field(form,'month',1,12);
this._y=this._field(form,'year',1900,2100);
const go=this.s('show_my_cards');
if(!go){
throw new Error('df-rr: <df-birth-cards> has no way to ask for a date — the page carries '
+'no `strings.show_my_cards` and no server-rendered [data-rr-birth-go] control in its '
+'light DOM. Ship one of the two; the server-rendered one costs no layout shift '
+'(contract #19).');
}
const b=el('button',{cls:'df-rr-btn',attrs:{type:'button'},text:go});
b.addEventListener('click',()=>this._show());
this._go=b;
this._err=el('p',{cls:'df-rr-birth__error',attrs:{'aria-live':'polite'}});
root.appendChild(form);
root.appendChild(this._pickerWrap);
root.appendChild(b);
root.appendChild(this._err);
}
const pickerShown=this._renderPicker(this._pickerWrap);
this._gate=pickerShown;
this._syncGate();
this._out=el('div',{cls:'df-rr-birth__out',attrs:{tabindex:'-1'}});
root.appendChild(this._out);
this._stop=inView(this,()=>this.track('tool_view',{tool:'birth-cards',deck:this._deck}));
if(this._deck&&!pickerShown)this.track('deck_pick',{tool:'birth-cards',deck:this._deck});
if(returnedFromForm()){
const back=birthDateRemembered();
if(back){
if(this._d)this._d.value=String(back.d);
if(this._m)this._m.value=String(back.m);
if(this._y)this._y.value=String(back.y);
this._show({scroll:false});
}
}
}
_availableDecks(){
return offerableDecks(this.data);
}
_renderIntro(parent){
const p=line('p',this.bs('what_are'),'df-rr-birth__what-are');
if(p)parent.appendChild(p);
return!!p;
}
_renderWhy(parent){
const bodyText=this.bs('why_body');
const paras=paragraphs(bodyText);
if(!paras.length)return false;
const head=line('h2',this.bs('why_heading'),'df-rr-birth__why-heading');
if(head)parent.appendChild(head);
const box=el('div',{
cls:'df-rr-birth__why',attrs:{'data-paragraphs':String(paras.length)},
});
for(const t of paras)box.appendChild(el('p',{cls:'df-rr-birth__why-para',text:t}));
parent.appendChild(box);
return true;
}
_renderPicker(parent){
const decks=this._availableDecks();
if(decks.length<2){this._chips=[];return false;}
const labelText=this.s('pick_deck');
const group=el('div',{
cls:'df-rr-picker df-rr-picker--decks',
attrs:{role:'radiogroup'},
});
if(labelText){
parent.appendChild(el('p',{cls:'df-rr-label',attrs:{id:'df-rr-birth-decklabel'},text:labelText}));
group.setAttribute('aria-labelledby','df-rr-birth-decklabel');
}
this._chips=[];
for(const d of decks){
const on=d.deck_id===this._deck;
const name=displayNameOf(d)||d.deck_id;
const chip=el('button',{
cls:'df-rr-chip df-rr-chip--deck'+(on?' is-on':''),
attrs:{type:'button',role:'radio','aria-checked':on?'true':'false','data-deck':d.deck_id},
});
const cover=deckChipImage(d);
if(cover){
const box=coverBox(d,300);
chip.appendChild(el('img',{
cls:'df-rr-chip__cover',
attrs:{src:cover,alt:'',width:box.width,height:box.height,loading:'lazy',decoding:'async'},
}));
}
chip.appendChild(el('span',{cls:'df-rr-chip__name',text:name}));
chip.addEventListener('click',()=>this._pickDeck(d.deck_id));
const cell=el('div',{cls:'df-rr-deckcell',attrs:{'data-deck':d.deck_id}});
cell.appendChild(chip);
group.appendChild(cell);
this._renderEnlarge(cell,group,d,name);
this._chips.push(chip);
}
parent.appendChild(group);
return true;
}
_renderEnlarge(cell,grid,deck,name){
const enlargeLabel=this.bs('enlarge');
const big=sized(deck.cover,['600','300']);
if(!enlargeLabel||!big)return null;
const panelId='df-rr-deckbig-'+deck.deck_id;
const btn=el('button',{
cls:'df-rr-deckcell__enlarge',
attrs:{
type:'button','aria-expanded':'false','aria-controls':panelId,
'aria-label':enlargeLabel+': '+name,
},
text:enlargeLabel,
});
const panel=el('div',{
cls:'df-rr-deckbig',
attrs:{id:panelId,hidden:'hidden',tabindex:'-1',role:'group','aria-label':name},
});
const bigBox=coverBox(deck,600);
panel.appendChild(el('img',{
cls:'df-rr-deckbig__img',
attrs:{src:big,alt:name,width:bigBox.width,height:bigBox.height,loading:'lazy',decoding:'async'},
}));
const seeLabel=this.bs('see_deck');
const url=deck.product?localPath(deck.product.url):null;
if(seeLabel&&url){
panel.appendChild(el('a',{
cls:'df-rr-deckbig__link',
attrs:{href:url,'data-deck':deck.deck_id},
text:seeLabel+' '+name,
}));
}
const close=()=>{
btn.setAttribute('aria-expanded','false');
panel.setAttribute('hidden','hidden');
};
btn.addEventListener('click',()=>{
const open=btn.getAttribute('aria-expanded')==='true';
for(const other of this._panels||[])other.close();
if(open)return;
btn.setAttribute('aria-expanded','true');
panel.removeAttribute('hidden');
focusTo(panel);
});
panel.addEventListener('keydown',(e)=>{
if(e.key!=='Escape'&&e.key!=='Esc')return;
close();
if(typeof btn.focus==='function')btn.focus();
});
(this._panels=this._panels||[]).push({close});
cell.appendChild(btn);
grid.appendChild(panel);
return btn;
}
_syncGate(){
if(!this._gate||!this._go)return;
const ready=!!this._deck;
if(ready){
this._go.removeAttribute('disabled');
this._go.removeAttribute('aria-disabled');
}else{
this._go.setAttribute('disabled','disabled');
this._go.setAttribute('aria-disabled','true');
}
}
_pickDeck(deckId){
if(DECK_IDS.indexOf(deckId)===-1||deckId===this._deck)return;
this._deck=deckId;
write('birth',{deck:deckId});
for(const chip of this._chips){
const on=chip.getAttribute('data-deck')===deckId;
chip.setAttribute('aria-checked',on?'true':'false');
chip.setAttribute('class','df-rr-chip df-rr-chip--deck'+(on?' is-on':''));
}
this.track('deck_pick',{tool:'birth-cards',deck:deckId});
this._syncGate();
if(this._cardEls)for(const c of this._cardEls)c.setAttribute('deck',deckId);
if(this._offerEl)this._offerEl.setAttribute('deck',deckId);
if(this._stripEl)this._paintStrip();
if(this._handoffEl){
const t=fill(this.s('deck_handoff'),{
deck:deckName(this.data,deckId),code:this._code,
});
if(t){
this._handoffEl.textContent=t;
this._handoffEl.setAttribute('data-clarity-mask','true');
}
}
}
_renderStrip(){
this._stripEl=null;
if(!this.bs('strip_line')||!this._code)return false;
if(!deckOf(this.data,this._deck))return false;
const box=el('section',{
cls:'df-rr-strip',
attrs:{'data-clarity-mask':'true'},
});
this._out.appendChild(box);
this._stripEl=box;
return this._paintStrip();
}
_paintStrip(){
const box=this._stripEl;
if(!box)return false;
const deck=deckOf(this.data,this._deck);
const text=fill(this.bs('strip_line'),{
deck:deckName(this.data,this._deck),code:this._code,
});
if(!deck||!text){clear(box);return false;}
clear(box);
box.setAttribute('data-deck',deck.deck_id);
box.setAttribute('data-code',this._code);
const cover=deckChipImage(deck);
if(cover){
const b=coverBox(deck,72);
box.appendChild(el('img',{
cls:'df-rr-strip__cover',
attrs:{src:cover,alt:'',width:b.width,height:b.height,loading:'lazy',decoding:'async'},
}));
}
const body=el('div',{cls:'df-rr-strip__body'});
const lineEl=el('p',{cls:'df-rr-strip__line',text,attrs:{'data-clarity-mask':'true'}});
body.appendChild(lineEl);
const status=el('p',{cls:'df-rr-strip__status',attrs:{'aria-live':'polite'}});
if(inStock(deck)){
const label=this.s('add_to_cart');
if(label){
const btn=el('button',{
cls:'df-rr-btn df-rr-strip__add',
attrs:{type:'button','data-deck':deck.deck_id,'data-code':this._code},
text:label,
});
btn.addEventListener('click',()=>{
offerAdd(this,{deck,tool:'birth-cards',button:btn,status,code:this._code});
});
body.appendChild(btn);
}
}else{
const back=this.s('back_soon');
if(back)body.appendChild(el('p',{cls:'df-rr-strip__backsoon',text:back}));
const alt=nextInStock(this.data,deck.deck_id);
const altUrl=alt&&alt.product?localPath(alt.product.url):null;
const altLabel=this.s('try_this_deck');
if(altUrl&&altLabel){
body.appendChild(el('a',{
cls:'df-rr-btn df-rr-strip__alt',
attrs:{href:altUrl,'data-deck':alt.deck_id},
text:altLabel+' '+(displayNameOf(alt)||alt.deck_id),
}));
}
}
body.appendChild(status);
box.appendChild(body);
return true;
}
_field(form,key,min,max){
const id='df-rr-birth-'+key;
const label=this.s('birth_'+key);
if(label)form.appendChild(el('label',{cls:'df-rr-label',attrs:{for:id},text:label}));
const input=el('input',{
cls:'df-rr-input',
attrs:{id,type:'number',inputmode:'numeric',min:String(min),max:String(max),autocomplete:'off'},
});
form.appendChild(input);
return input;
}
_read(input){
const n=Number(input&&input.value);
return Number.isInteger(n)?n:NaN;
}
_glance(rd,count){
const setKey=count===1?'birth_set_one':count===2?'birth_set_two':'birth_set_three';
const setWord=this.s(setKey);
const NOTES={gifts:'gift_notes',challenges:'challenge_notes',advice:null};
const rows=GLANCE.map(([kind,key])=>({
kind,label:fill(this.s(key),{set:setWord}),items:rd[kind],
notes:NOTES[kind]?rd[NOTES[kind]]:null,
}));
if(rows.some((row)=>!row.label||!row.items))return null;
const box=el('section',{cls:'df-rr-birth__glance'});
let used=0;
for(const row of rows){
const group=el('div',{cls:'df-rr-birth__glance-group',attrs:{'data-kind':row.kind}});
group.appendChild(el('h3',{cls:'df-rr-birth__glance-label',text:row.label}));
const list=el('ul',{cls:'df-rr-birth__glance-list'});
for(let i=0;i<row.items.length;i++){
const item=row.items[i];
const li=el('li',{cls:'df-rr-birth__glance-item'});
li.appendChild(el('span',{cls:'df-rr-birth__glance-item-text',text:item}));
used+=words(item);
const note=row.notes?str(row.notes[i]):null;
if(note){
li.appendChild(el('span',{cls:'df-rr-birth__glance-item-note',text:' — '+note}));
used+=words(note);
}
list.appendChild(li);
}
group.appendChild(list);
box.appendChild(group);
}
return{node:box,words:used};
}
_show(opts){
clear(this._out);
this._err.textContent='';
const y=this._read(this._y),m=this._read(this._m),d=this._read(this._d);
const bad=!Number.isInteger(y)||!Number.isInteger(m)||!Number.isInteger(d)
||y<1||y>9999||m<1||m>12||d<1||d>daysInMonth(y,m);
if(bad){
this._release();
this._err.textContent=this.s('birth_bad_date')||'';
return;
}
if(this._gate&&!this._deck){
this._release();
this._err.textContent=this.s('pick_deck')||'';
return;
}
rememberBirthDate({y,m,d});
const data=this.data;
if(deferred(data)){
this._out.setAttribute('aria-busy','true');
this._reserve(y,m,d);
this._out.appendChild(busyNode());
loadBundle(data,this._opts).then(()=>{
if(!this.alive)return;
this._out.removeAttribute('aria-busy');
clear(this._out);
this._doShow(y,m,d,opts);
});
return;
}
this._reserve(y,m,d);
this._doShow(y,m,d,opts);
}
_cardSection(id){
const card=own(this.data.cards,id)||{};
const name=str(card.name);
if(!name)return null;
const sec=el('section',{cls:'df-rr-birth__card',attrs:{'data-card-id':id}});
sec.appendChild(el('h3',{cls:'df-rr-birth__card-name',text:name}));
let used=words(name);
let lines=0;
for(const[field,labelKey]of CARD_LINES){
const v=str(own(card,field));
if(!v)continue;
const label=this.bs(labelKey);
if(label){
sec.appendChild(el('h4',{
cls:'df-rr-birth__topic',attrs:{'data-topic':labelKey},text:label,
}));
}
used+=words(v);
sec.appendChild(el('p',{cls:'df-rr-birth__'+field,text:v}));
lines++;
}
if(!lines)return null;
return{node:sec,words:used};
}
_renderMethod(y,m,d,r){
if(!(this.data.flags&&this.data.flags.birth_arithmetic_verified===true))return null;
const chain=birthArithmeticChain(y,m,d,r);
if(!chain)return null;
const sumText=fill(this.s('birth_from_your_date'),{sum:chain});
if(!sumText)return null;
const box=el('section',{cls:'df-rr-birth__method'});
let used=0;
const heading=this.bs('method_sum');
if(heading)box.appendChild(el('h3',{cls:'df-rr-birth__method-title',text:heading}));
const credit=this.bs('where_from');
const intro=line('p',credit,'df-rr-birth__method-intro');
if(intro){box.appendChild(intro);used+=words(credit);}
box.appendChild(el('p',{cls:'df-rr-birth__arithmetic',text:sumText}));
return{node:box,words:used};
}
_renderYearCard(m,d){
if(!(this.data.flags&&this.data.flags.year_card===true))return null;
const calendarYear=Number(this.data.year_now);
if(!Number.isInteger(calendarYear))return null;
let yc=null;
try{yc=yearCard(m,d,calendarYear);}catch{return null;}
if(!inWrittenRange(yc.number))return null;
const title=this.bs('year_card_title');
const teaser=this.bs('year_card_teaser');
if(!title||!teaser)return null;
const box=el('section',{
cls:'df-rr-birth__year',
attrs:{'data-year-card':yc.roman},
});
box.appendChild(el('h3',{cls:'df-rr-birth__year-title',text:title}));
box.appendChild(el('p',{cls:'df-rr-birth__year-teaser',text:teaser}));
return{node:box,words:words(teaser),roman:yc.roman};
}
_reserve(y,m,d){
try{
const r=birthCards(y,m,d);
const key=pairKeyFromParts(r.primary,r.secondary,r.tertiary);
const width=Number(globalThis.innerWidth)||390;
const px=reserveFor(key,width);
if(px)this._out.style.minHeight=px+'px';
}catch{}
}
_release(){
try{
const style=this._out.style;
if(!style||!style.minHeight)return;
const reserved=parseInt(style.minHeight,10);
if(typeof this._out.getBoundingClientRect!=='function'||!Number.isFinite(reserved)){
style.minHeight='';
return;
}
style.minHeight='';
const content=this._out.getBoundingClientRect().height;
if(content>=reserved)return;
style.minHeight=reserved+'px';
const hand=()=>{
if(this._unreserve){this._unreserve();this._unreserve=null;}
try{this._out.style.minHeight='';}catch{}
};
const g=globalThis;
const scrollAtReveal=Number(g.scrollY)||0;
const arm=()=>{
if(!this.alive)return;
if((Number(g.scrollY)||0)!==scrollAtReveal){hand();return;}
const on=[];
for(const type of['scroll','pointerdown','keydown']){
if(g&&typeof g.addEventListener==='function'){
g.addEventListener(type,hand,{once:true,passive:true});
on.push(()=>{try{g.removeEventListener(type,hand);}catch{}});
}
}
this._unreserve=()=>{for(const off of on)off();};
};
const timer=typeof g.setTimeout==='function'?g.setTimeout(arm,400):null;
this._unreserve=()=>{if(timer!==null&&typeof g.clearTimeout==='function')g.clearTimeout(timer);};
}catch{}
}
_doShow(y,m,d,opts){
const scroll=!(opts&&opts.scroll===false);
const r=birthCards(y,m,d);
const ids=[r.primary,r.secondary,r.tertiary]
.filter((n)=>n!==null)
.map((n)=>'major-'+String(n).padStart(2,'0'));
this._shown={y,m,d};
const yourCards=this.bs('your_cards');
let head=null;
if(yourCards){
head=el('h2',{
cls:'df-rr-birth__heading',attrs:{tabindex:'-1'},text:yourCards,
});
this._out.appendChild(head);
}
const row=el('div',{cls:'df-rr-birth__cards'});
this._cardEls=[];
for(const id of ids){
const c=cardNode(this.data,{cardId:id,deck:this._deck,size:'450'});
if(c){row.appendChild(c);this._cardEls.push(c);}
}
if(row.childNodes.length)this._out.appendChild(row);
for(const c of this._cardEls)c.mountWith(this.data,this._opts);
this._code=birthdayCode(ids);
this._renderStrip();
const{reading:rd}=readBirthReading(this.data.strings,{
primary:r.primary,secondary:r.secondary,tertiary:r.tertiary,
});
const bodyText=rd.body||rd.theme;
const bodyParas=paragraphs(bodyText);
const cardSections=ids.map((id)=>this._cardSection(id)).filter((s)=>s!==null);
const links=this._learnList(ids);
const glance=this._glance(rd,ids.length);
const method=this._renderMethod(y,m,d,r);
const glanceIntroText=this.s('birth_glance_intro');
const reserved=words(bodyText)+words(rd.asks)+words(rd.action)
+cardSections.reduce((a,s)=>a+s.words,0)+links.words
+(glance?glance.words:0)+(method?method.words:0);
let budget=WORD_CAP-reserved;
const dropped=[];
const add=(node,w,what)=>{
if(!node)return false;
if(w>budget){dropped.push(what+' ('+w+' words, '+Math.max(budget,0)+' left)');return false;}
budget-=w;
this._out.appendChild(node);
return true;
};
if(method)this._out.appendChild(method.node);
const whoYouAre=this.bs('who_you_are');
if(bodyParas.length){
if(whoYouAre)this._out.appendChild(el('h3',{cls:'df-rr-birth__body-title',text:whoYouAre}));
const body=el('div',{cls:'df-rr-birth__body',attrs:{'data-paragraphs':String(bodyParas.length)}});
for(const p of bodyParas)body.appendChild(el('p',{cls:'df-rr-birth__theme',text:p}));
this._out.appendChild(body);
}
if(glance){
add(line('p',glanceIntroText,'df-rr-birth__glance-intro'),words(glanceIntroText),'the glance intro');
this._out.appendChild(glance.node);
}
for(const sec of cardSections)this._out.appendChild(sec.node);
if(links.node)this._out.appendChild(links.node);
const asksNode=line('p',rd.asks,'df-rr-birth__asks');
if(asksNode)this._out.appendChild(asksNode);
const actionNode=line('p',rd.action,'df-rr-birth__action');
if(actionNode)this._out.appendChild(actionNode);
const year=this._renderYearCard(m,d);
if(year)this._out.appendChild(year.node);
this._words=reserved+(year?year.words:0);
if(dropped.length||reserved>WORD_CAP){
const over=reserved>WORD_CAP?reserved-WORD_CAP:0;
if(globalThis.console&&globalThis.console.warn){
globalThis.console.warn('[df-rr] birth reading over the '+WORD_CAP+'-word cap for '
+pairKeyFromParts(r.primary,r.secondary,r.tertiary)+': '
+(over?'the reading itself is '+over+' words over, rendered in full. ':'')
+(dropped.length?'not rendered: '+dropped.join('; ')+'.':''));
}
}
const handoff=line('p',fill(this.s('deck_handoff'),{
deck:deckName(this.data,this._deck),code:this._code,
}),'df-rr-handoff');
this._handoffEl=handoff||null;
if(handoff){
handoff.setAttribute('data-clarity-mask','true');
if(this._code)handoff.setAttribute('data-code',this._code);
this._out.appendChild(handoff);
}
const offer=globalThis.document.createElement('df-deck-offer');
offer.setAttribute('deck',this._deck);
offer.setAttribute('tool','birth-cards');
if(this._code)offer.setAttribute('code',this._code);
this._out.appendChild(offer);
offer.mountWith(this.data,this._opts);
this._offerEl=offer;
const anotherText=this.bs('another_date');
if(anotherText){
const again=el('button',{
cls:'df-rr-btn df-rr-birth__again',
attrs:{type:'button'},
text:anotherText,
});
again.addEventListener('click',()=>{
this._release();
clear(this._out);
this._shown=null;
this._cardEls=[];
this._offerEl=null;
this._stripEl=null;
if(this._d&&typeof this._d.focus==='function')this._d.focus();
});
this._out.appendChild(again);
}
const readingKey=String(y)+'-'+String(m)+'-'+String(d);
if(this._revealed!==readingKey){
this._revealed=readingKey;
this.track('reveal',{tool:'birth-cards',deck:this._deck,reversed_count:0});
}
const endAnchor=actionNode||asksNode||(row.childNodes.length?row:null);
if(endAnchor){
if(this._stopEnd)this._stopEnd();
this._stopEnd=inView(endAnchor,()=>{
if(this._endFired===readingKey)return;
this._endFired=readingKey;
this.track('reading_end',{tool:'birth-cards',deck:this._deck,reversed_count:0});
});
}
if(year){
if(this._stopYear)this._stopYear();
this._stopYear=inView(year.node,()=>{
if(this._yearFired===readingKey)return;
this._yearFired=readingKey;
this.track('year_card_view',{tool:'birth-cards',deck:this._deck});
});
}
this._wireEmail(ids[0]);
this._out.setAttribute('data-deck',this._deck||'');
this._out.setAttribute('data-birth-outcome',pairKeyFromParts(r.primary,r.secondary,r.tertiary));
if(this._code)this._out.setAttribute('data-birth-code',this._code);
this._out.setAttribute('data-clarity-mask','true');
focusTo(head||this._out);
if(scroll)this._revealScroll(head||row);
this._release();
this.fire('df-reading',{
primary:r.primary,
secondary:r.secondary,
tertiary:r.tertiary,
deck:this._deck||null,
outcome:pairKeyFromParts(r.primary,r.secondary,r.tertiary),
code:this._code,
});
}
_learnList(ids){
const ul=el('ul',{cls:'df-rr-learn'});
let used=0;
for(const id of ids){
const card=own(this.data.cards,id)||{};
const url=localPath(card.article_url);
const name=str(card.name);
if(!url||!name)continue;
const a=el('a',{cls:'df-rr-learn__link',attrs:{href:url},text:name});
a.addEventListener('click',()=>this.track('learn_click',{tool:'birth-cards',deck:this._deck}));
ul.appendChild(el('li',null,[a]));
used+=words(name);
}
return{node:ul.childNodes.length?ul:null,words:used};
}
_revealScroll(node){
if(!node||typeof node.scrollIntoView!=='function')return;
try{
node.scrollIntoView({block:'start',behavior:'auto'});
const by=globalThis.scrollBy;
if(typeof by==='function')by({top:-REVEAL_OFFSET,left:0,behavior:'auto'});
}catch{}
}
_emailForm(){
const given=this._opts&&this._opts.emailForm;
if(given&&typeof given.addEventListener==='function')return given;
const inside=this.adopted('birth-email');
if(inside)return inside;
try{
const d=globalThis.document;
return(d&&typeof d.querySelector==='function')?d.querySelector('[data-rr-birth-email]'):null;
}catch{
return null;
}
}
_wireEmail(primaryCardId){
this._primaryCard=primaryCardId||null;
if(this._emailWired)return;
const form=this._emailForm();
if(!form||typeof form.addEventListener!=='function')return;
this._emailWired=true;
this.wire(form,'submit',()=>{
this.track('email_submit',{
tool:'birth-cards',deck:this._deck,primary_card:this._primaryCard,
});
});
}
destroy(){
if(this._stop)this._stop();
if(this._stopEnd)this._stopEnd();
if(this._stopYear)this._stopYear();
if(this._unreserve){this._unreserve();this._unreserve=null;}
if(this._idle)this._idle();
if(this._pickerInserted&&this._pickerWrap&&this._pickerWrap.parentNode){
this._pickerWrap.parentNode.removeChild(this._pickerWrap);
}
this._pickerInserted=false;
if(this._go&&typeof this._go.removeAttribute==='function'){
this._go.removeAttribute('disabled');
this._go.removeAttribute('aria-disabled');
}
this._panels=[];
super.destroy();
}
};
}

return { "WORD_CAP": WORD_CAP, "REVEAL_OFFSET": REVEAL_OFFSET, "CARD_SLUG": CARD_SLUG, "birthdayCode": birthdayCode, "BIRTH_LABEL_KEYS": BIRTH_LABEL_KEYS, "CARD_LINES": CARD_LINES, "coverBox": coverBox, "normaliseBirthReading": normaliseBirthReading, "GLANCE": GLANCE, "pairKeyFromParts": pairKeyFromParts, "readBirthReading": readBirthReading, "makeBirthCardsEl": makeBirthCardsEl };
})();

__m["mount"] = (function () {
const{makeBase}=__m["base"];
const{makeCardEl}=__m["card-el"];
const{makeRevealEl}=__m["reveal-el"];
const{makeReadItYourselfEl}=__m["read-it-yourself-el"];
const{makeDeckOfferEl}=__m["deck-offer-el"];
const{makeAiNoteEl}=__m["ai-note-el"];
const{makeTableEl}=__m["table-el"];
const{makeYesNoEl}=__m["yes-no-el"];
const{makeDailyEl}=__m["daily-el"];
const{makeBirthCardsEl}=__m["birth-cards-el"];
const{SCHEMA_VERSION,LANGS}=__m["compose"];
const DATA_ID='df-rr-data';
const TAGS=Object.freeze({
'df-card':makeCardEl,
'df-reveal':makeRevealEl,
'df-read-it-yourself':makeReadItYourselfEl,
'df-deck-offer':makeDeckOfferEl,
'df-ai-note':makeAiNoteEl,
'df-table':makeTableEl,
'df-yes-no':makeYesNoEl,
'df-daily-card':makeDailyEl,
'df-birth-cards':makeBirthCardsEl,
});
function define(){
const ce=globalThis.customElements;
if(!ce||typeof ce.define!=='function')return false;
const Base=makeBase();
for(const tag of Object.keys(TAGS)){
if(ce.get&&ce.get(tag))continue;
ce.define(tag,TAGS[tag](Base));
}
return true;
}
function readData(doc){
const node=doc.getElementById(DATA_ID);
if(!node)throw new Error('df-rr: no #'+DATA_ID+' block on this page');
let data;
try{
data=JSON.parse(node.textContent||'');
}catch{
throw new Error('df-rr: #'+DATA_ID+' is not valid JSON');
}
if(!data||typeof data!=='object'||Array.isArray(data))throw new Error('df-rr: #'+DATA_ID+' is not an object');
if(data.v!==SCHEMA_VERSION)throw new Error('df-rr: page data version '+data.v+' is not one this engine knows');
if(typeof data.lang!=='string'||LANGS.indexOf(data.lang)===-1)throw new Error('df-rr: unknown lang');
return data;
}
function mount(rootEl,opts){
const o=opts||{};
if(!rootEl||typeof rootEl.tagName!=='string')throw new TypeError('df-rr: mount needs an element');
const doc=rootEl.ownerDocument||globalThis.document;
const data=o.data||readData(doc);
define();
const tag=rootEl.tagName.toLowerCase();
const tool=typeof o.tool==='string'?o.tool:data.tool;
if(typeof rootEl.mountWith!=='function'){
return{destroy(){},el:rootEl,tool,mounted:false};
}
if(rootEl.mounted)return{destroy:()=>rootEl.destroy(),el:rootEl,tool,mounted:true};
try{
rootEl.mountWith(data,{questionEl:o.questionEl||null,deck:o.deck,now:o.now,fetchImpl:o.fetchImpl});
}catch(e){
if(globalThis.console&&globalThis.console.warn)globalThis.console.warn('df-rr: '+tag+' did not mount',e);
return{destroy(){},el:rootEl,tool,mounted:false};
}
return{destroy:()=>rootEl.destroy(),el:rootEl,tool,mounted:true};
}
function mountAll(doc,opts){
const d=doc||globalThis.document;
const out=[];
for(const tag of Object.keys(TAGS)){
const nodes=d.querySelectorAll?d.querySelectorAll(tag):[];
for(let i=0;i<nodes.length;i++){
if(nodes[i].closest&&nodes[i].parentNode&&nodes[i].closest('df-table, df-yes-no, df-daily-card, df-birth-cards')!==nodes[i])continue;
out.push(mount(nodes[i],opts));
}
}
return out;
}

return { "DATA_ID": DATA_ID, "TAGS": TAGS, "define": define, "readData": readData, "mount": mount, "mountAll": mountAll };
})();

var __engine={};
for(var __n_text in __m["text"])__engine[__n_text]=__m["text"][__n_text];
for(var __n_dates in __m["dates"])__engine[__n_dates]=__m["dates"][__n_dates];
for(var __n_cards in __m["cards"])__engine[__n_cards]=__m["cards"][__n_cards];
for(var __n_rng in __m["rng"])__engine[__n_rng]=__m["rng"][__n_rng];
for(var __n_shuffle in __m["shuffle"])__engine[__n_shuffle]=__m["shuffle"][__n_shuffle];
for(var __n_draw in __m["draw"])__engine[__n_draw]=__m["draw"][__n_draw];
for(var __n_lean in __m["lean"])__engine[__n_lean]=__m["lean"][__n_lean];
for(var __n_notices in __m["notices"])__engine[__n_notices]=__m["notices"][__n_notices];
for(var __n_yesno in __m["yesno"])__engine[__n_yesno]=__m["yesno"][__n_yesno];
for(var __n_compose in __m["compose"])__engine[__n_compose]=__m["compose"][__n_compose];
for(var __n_daily in __m["daily"])__engine[__n_daily]=__m["daily"][__n_daily];
for(var __n_birth_cards in __m["birth-cards"])__engine[__n_birth_cards]=__m["birth-cards"][__n_birth_cards];
for(var __n_personal_year in __m["personal-year"])__engine[__n_personal_year]=__m["personal-year"][__n_personal_year];
for(var __n_life_path in __m["life-path"])__engine[__n_life_path]=__m["life-path"][__n_life_path];
for(var __n_serialise in __m["serialise"])__engine[__n_serialise]=__m["serialise"][__n_serialise];
var __mount=__m['mount'];
var DF=(globalThis.DF=globalThis.DF||{});
DF.ReadingRoom={version:'1.0.0',mount:__mount.mount,engine:__engine,define:__mount.define};
__mount.define();

})();
